<template>
  <el-aside :width="this.aside_width">
    <el-card class="chat-dialog-card">
      <!-- 控制按钮区域 - サポート開始、一時停止など -->
      <div
        class="el-controlbar"
        :class="[
          this.$store.state.sysInit.personalSingleMode == 'MANUAL_CHAT_MODE'
            ? 'controlbar-chat'
            : '',
        ]"
      >
        <el-row>
          <CallStartButton
            v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'"
          ></CallStartButton>
          <ManualChatButton
            v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
          ></ManualChatButton>

          <span v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'">
            <el-button
              size="small"
              :type="this.$store.state.stt.stopStatus"
              plain
              :disabled="
                this.$store.state.sysInit.talkStatus === 'end'
                  ? true
                  : !$store.state.stt.isMicOn
              "
              v-if="!$store.state.stt.isMicPause"
              @click="turnMicPause"
            >
              <icon name="pause"></icon
              >{{ this.$store.state.sysInit.html_const.cons_207_pause }}
              <!-- 一時停止 -->
            </el-button>
            <el-button
              size="small"
              type="primary"
              plain
              :disabled="
                this.$store.state.sysInit.talkStatus === 'end'
                  ? true
                  : !$store.state.stt.isMicOn
              "
              v-if="$store.state.stt.isMicPause"
              @click="turnMicOn"
            >
              <icon name="play"></icon
              >{{ this.$store.state.sysInit.html_const.cons_208_restart }}
              <!-- 再開 -->
            </el-button>
            <div class="record">
              <!-- 通話時間 -->
              {{ this.$store.state.sysInit.html_const.cons_209_start_time }}　{{
                callDuration
              }}
            </div>
          </span>
          <!-- 保留開始 -->
          <HoldStartButton
            v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
          ></HoldStartButton>
        </el-row>
        <el-row>
          <div class="selectStatus">
            <label class="el-checkbox is-checked" style="padding-right: 4px"
              ><span class="el-checkbox__input is-checked"
                ><span class="el-checkbox__inner"></span
                ><input
                  type="checkbox"
                  aria-hidden="false"
                  class="el-checkbox__original"
                  value="" /></span
              ><!----></label
            >
            <!-- ジャンプ -->
            <span style="padding-right: 6px">{{ this.$store.state.sysInit.html_const.cons_212_jump }}</span>

            <el-button @click="upSelect" type="info" class="search-nav-btn gray-button" icon="el-icon-caret-top" style="margin-left: 1%">
            </el-button>
            <span v-if="multipleSelection.length" style="padding: 0 0px ;font-weight:bold"
              >{{ searchIndex + 1 }}/{{ multipleSelection.length }}
            </span>
            <span v-else-if="multipleSelection.length == 0" style="padding: 0 6px ;font-weight:bold">0/0</span>

            <el-button @click="downSelect" type="info" class="search-nav-btn gray-button" icon="el-icon-caret-bottom">
            </el-button>
            
          </div>

          <!-- 非MANUAL_CHAT_MODE -->
          <span v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'">
            <!-- 【検索クリア】按钮。点击后把所有Switch关闭 -->
            <el-button @click="turnOffSwitch()" size="mini">
              {{ this.$store.state.sysInit.html_const.cons_213_clear_search }}
            </el-button>
            <el-button
              size="small"
              :type="this.$store.state.stt.scrollStatus"
              plain
              :disabled="
                this.$store.state.sysInit.talkStatus === 'end'
                  ? true
                  : !$store.state.stt.isMicOn
              "
              @click="stopScrollControl"
              v-if="this.$store.state.stt.scrollFlag"
            >
              <icon name="pause"></icon>
              <!-- スクロール停止 -->
              {{ this.$store.state.sysInit.html_const.cons_214_scroll_pause }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              plain
              :disabled="!$store.state.stt.isMicOn"
              @click="startScrollControl"
              v-else
            >
              <icon name="play"></icon>
              <!-- スクロール再開 -->
              {{ this.$store.state.sysInit.html_const.cons_215_scroll_reopen }}
            </el-button>
          </span>
          <!-- MANUAL_CHAT_MODE -->
          <span v-else>
            <!-- 【検索クリア】按钮。点击后把所有Switch关闭 -->
            <el-button @click="turnOffSwitch()" size="mini">
              {{ this.$store.state.sysInit.html_const.cons_213_clear_search }}
            </el-button>

            <el-button
              size="small"
              :type="this.$store.state.stt.scrollStatus"
              plain
              :disabled="true"
              @click="stopScrollControl"
              v-if="this.$store.state.stt.scrollFlag"
            >
              <icon name="pause"></icon>
              <!-- スクロール停止 -->
              {{ this.$store.state.sysInit.html_const.cons_214_scroll_pause }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              plain
              :disabled="true"
              @click="startScrollControl"
              v-else
            >
              <icon name="play"></icon>
              <!-- スクロール再開 -->
              {{ this.$store.state.sysInit.html_const.cons_215_scroll_reopen }}
            </el-button>
          </span>
        </el-row>
      </div>
      <!-- F2F和电话模式下未开始通话/录音前聊天内容展示区域默认展示的文本 -->
      <div
        class="chat-content"
        v-if="
          !$store.state.stt.isMicOn &&
          $store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'
        "
      >
        <span
          v-html="
            this.$store.state.sysInit.html_const
              .cons_218_chat_history_default_msg
          "
        >
          <!-- 音声会話を開始する場合は <b> 通話開始 </b> ボタンをクリックして会話を開始してください。
          <br>
          過去の応対履歴はこちらから閲覧できます。 -->
        </span>
      </div>
      <!-- 聊天内容展示区域 -->
      <section
        v-else
        :class="[
          this.$store.state.sysInit.personalSingleMode == 'MANUAL_CHAT_MODE'
            ? 'result-content-chat'
            : 'result-content',
        ]"
        ref="sectionChat"
      >
        <!-- 非CHAT模式 -->
        <span v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'">
          <el-table
            class="chat"
            :data="sttNotes"
            ref="multipleTable"
            @row-click="selectRow"
            @selection-change="handleSelectionChange"
            :show-header="false"
            highlight-current-row
            height="100%"
            @mouseenter.native="onMouseEnter"
            @mouseleave.native="onMouseLeave"
            :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
          >
            <template>
              <div
                slot="empty"
                v-if="$store.state.stt.chat_empty_text_status == 'listening'"
                style="color: #303133"
              >
                {{ this.$store.state.sysInit.html_const.cons_219_no_data }}
              </div>
              <div
                slot="empty"
                v-else-if="
                  $store.state.stt.chat_empty_text_status == 'timed_out'
                "
              >
                {{ this.$store.state.sysInit.html_const.cons_219_no_data }}
              </div>
              <div slot="empty" v-else-if="this.emptyTextStatus != 'start'">
                {{ this.$store.state.sysInit.html_const.cons_219_no_data }}
              </div>
              <div
                slot="empty"
                v-else-if="this.emptyTextStatus == 'start'"
                style="line-height: 20px; width: 100%"
              >
                {{
                  this.$store.state.sysInit.html_const.cons_261_watson_starting
                }}
              </div>
            </template>
            <el-table-column type="selection" width="45" align="center">
            </el-table-column>
            <el-table-column width="55" align="center">
              <template slot-scope="scope">
                <span :class="{'switch-wrapper': !scope.row.text}" @click.stop="">
                  <input
                    :class="{
                      'switch': true,
                      'switch-animbg': true,
                      'switch-disabled': !scope.row.text
                    }"
                    v-model="scope.row.checked"
                    @change="changeSwitch(scope.row)"
                    type="checkbox"
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div
                  style="padding-right: 5px"
                  class="message_msg"
                  :class="{
                    left: scope.row.flag == 'right',
                    right: scope.row.flag == 'left',
                  }"
                >
                  <div class="user_headshot" style="background-color: #f2f2f2">
                    <!-- <img src="../assets/img/user_logo.png" v-if="scope.row.flag == 'right'"> -->
                    <!-- <img src="../assets/img/operator.png" v-else> -->
                    <!-- <img
                      :src="$store.state.sysInit.questioner_logo"
                      v-if="scope.row.flag == 'right'"
                    />
                    <img :src="$store.state.sysInit.operator_logo" v-else /> -->
                    <!-- <img src="../assets/img/watson_think_stop.gif" v-else> -->

                    <span
                      v-if="
                        $store.state.sysInit.ws_mode ===
                        'NEXMO_ASTERISK_PBX_MODE'
                      "
                    >
                      <img
                        :src="$store.state.sysInit.phone_questioner_logo"
                        v-if="scope.row.flag == 'right'"
                      />
                      <img :src="$store.state.sysInit.operator_logo" v-else />
                    </span>
                    <span
                      v-if="$store.state.sysInit.ws_mode === 'STAND_MIC_MODE'"
                    >
                      <img
                        :src="$store.state.sysInit.questioner_logo"
                        v-if="scope.row.flag == 'right'"
                      />
                      <img :src="$store.state.sysInit.operator_logo" v-else />
                    </span>
                  </div>
                  <div class="user_msg">
                    <div
                      v-if="$store.state.sysInit.ws_mode ==='NEXMO_ASTERISK_PBX_MODE'"
                      class="speaker"
                    >
                      {{ scope.row.username }}
                    </div>
                    <div
                      v-if="$store.state.sysInit.ws_mode === 'STAND_MIC_MODE'"
                      class="speaker"
                    >
                      {{ scope.row.username }}
                    </div>
                    <!-- F2F和电话模式没有富文本 -->
                    <div class="user_text">{{ scope.row.text }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </span>
        <!-- CHAT模式 -->
        <span v-else>
          <!-- 显示等待列表 -->
          <span v-if="$store.state.sysInit.manualChatShowWaitingListFlg">
            <el-table
              class="chat"
              :data="this.$store.state.sysInit.manualChatMessageList"
              ref="multipleTable"
              :show-header="false"
              highlight-current-row
              height="98%"
              @mouseenter.native="onMouseEnter"
              @mouseleave.native="onMouseLeave"
              :empty-text="
                this.$store.state.sysInit.html_const.cons_219_no_data
              "
            >
              <el-table-column type="selection" width="45" align="center">
                <template
                  slot-scope="scope"
                  v-if="
                    scope.row.userId ==
                      $store.state.sysInit.manualChatCreateIssueUserId &&
                    scope.row.issueId ==
                      $store.state.sysInit.manualChatModeIssueId
                  "
                >
                  <span v-if="scope.row.checkBoxFlg">
                    <el-checkbox
                      type="selection"
                      @change="handleSelectionChange"
                      :checked="scope.row.checkBoxFlg"
                    ></el-checkbox>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="55" align="center">
                <template
                  slot-scope="scope"
                  v-if="
                    scope.row.userId ==
                      $store.state.sysInit.manualChatCreateIssueUserId &&
                    scope.row.issueId ==
                      $store.state.sysInit.manualChatModeIssueId
                  "
                >
                  <span :class="{'switch-wrapper': !scope.row.text}" @click.stop="">
                    <input
                      :class="{
                        'switch': true,
                        'switch-animbg': true,
                        'switch-disabled': !scope.row.text
                      }"
                      v-model="scope.row.checked"
                      @change="changeSwitch(scope.row)"
                      type="checkbox"
                      disabled
                    />
                  </span>
                </template>
              </el-table-column>
              <el-table-column>
                <template
                  slot-scope="scope"
                  v-if="
                    scope.row.userId ==
                      $store.state.sysInit.manualChatCreateIssueUserId &&
                    scope.row.issueId ==
                      $store.state.sysInit.manualChatModeIssueId
                  "
                >
                  <div
                    style="padding-right: 5px"
                    class="message_msg"
                    :class="{
                      left: scope.row.flag == 'right',
                      right: scope.row.flag == 'left',
                    }"
                  >
                    <div
                      class="user_headshot"
                      style="background-color: #f2f2f2"
                    >
                      <img
                        :src="scope.row.logo_url"
                        v-if="scope.row.flag == 'right'"
                      />
                      <!-- {{scope.row.logo_url}} -->

                      <span v-if="scope.row.role == 'supervisor'">
                        <img :src="scope.row.logo_url" />
                      </span>
                      <span v-else>
                        <img
                          :src="$store.state.sysInit.operator_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username !=
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            !scope.row.isChatbot
                          "
                        />
                        <img
                          :src="$store.state.sysInit.watson_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username ==
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            scope.row.isChatbot
                          "
                        />
                        <img
                          :src="$store.state.sysInit.watson_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username ==
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            !scope.row.isChatbot
                          "
                        />
                      </span>
                    </div>
                    <div class="user_msg">
                      <span>
                        <div
                          class="speaker"
                          v-if="
                            scope.row.userId ==
                              $store.state.sysInit
                                .manualChatCreateIssueUserId &&
                            scope.row.issueId ==
                              $store.state.sysInit.manualChatModeIssueId
                          "
                        >
                          {{ scope.row.username }}
                        </div>
                        <div
                          class="user_text"
                          v-if="
                            scope.row.userId ==
                              $store.state.sysInit
                                .manualChatCreateIssueUserId &&
                            scope.row.issueId ==
                              $store.state.sysInit.manualChatModeIssueId
                          "
                        >
                          <span
                            class="ql-editor"
                            v-html="scope.row.editorText || scope.row.text"
                            style="padding: 4px 0px"
                          >
                          </span>
                        </div>
                      </span>
                      <br />
                      <div
                        style="float: right; font-size: 12px"
                        v-if="
                          scope.row.userId ==
                            $store.state.sysInit.manualChatCreateIssueUserId &&
                          scope.row.flag == 'left'
                        "
                      >
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                      <div
                        style="float: left; font-size: 12px"
                        v-if="
                          scope.row.userId ==
                            $store.state.sysInit.manualChatCreateIssueUserId &&
                          scope.row.flag == 'right'
                        "
                      >
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </span>
          <!-- 不显示等待列表 -->
          <span v-else>
            <el-table
              class="chat"
              :data="this.$store.state.sysInit.manualChatMessageList"
              ref="multipleTable"
              @row-click="selectRow"
              @selection-change="handleSelectionChange"
              :show-header="false"
              highlight-current-row
              height="98%"
              @mouseenter.native="onMouseEnter"
              @mouseleave.native="onMouseLeave"
              :empty-text="
                this.$store.state.sysInit.html_const.cons_219_no_data
              "
            >
              <!-- 开启多选功能 -->
              <el-table-column type="selection" width="45" align="center"></el-table-column>
              <!-- 开关 -->
              <el-table-column width="55" align="center">
                <template
                  slot-scope="scope"
                  v-if="
                    scope.row.userId ==
                      $store.state.sysInit.manualChatQuestionerId &&
                    scope.row.issueId ==
                      $store.state.sysInit.manualChatModeIssueId
                  "
                >
                  <span :class="{'switch-wrapper': !scope.row.text}" @click.stop="">
                    <input
                      :class="{
                        'switch': true,
                        'switch-animbg': true,
                        'switch-disabled': !scope.row.text
                      }"
                      v-model="scope.row.checked"
                      @change="changeSwitch(scope.row)"
                      type="checkbox"
                    />
                  </span>
                </template>
              </el-table-column>
              <!-- 聊天内容 -->
              <el-table-column>
                <template
                  slot-scope="scope"
                  v-if="
                    scope.row.userId ==
                      $store.state.sysInit.manualChatQuestionerId &&
                    scope.row.issueId ==
                      $store.state.sysInit.manualChatModeIssueId
                  "
                >
                  <div
                    style="padding-right: 5px"
                    class="message_msg"
                    :class="{
                      left: scope.row.flag == 'right',
                      right: scope.row.flag == 'left',
                    }"
                  >
                    <!-- 头像 -->
                    <div
                      class="user_headshot"
                      style="background-color: #f2f2f2"
                    >
                      <img
                        :src="scope.row.logo_url"
                        v-if="scope.row.flag == 'right'"
                      />
                      <!-- SV头像 -->
                      <span v-if="scope.row.role == 'supervisor'">
                        <img :src="scope.row.logo_url" />
                      </span>
                      <!-- OP或もっぴー的头像 -->
                      <span v-else>
                        <!-- OP头像 -->
                        <img
                          :src="$store.state.sysInit.operator_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username !=
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            !scope.row.isChatbot
                          "
                        />
                        <!-- もっぴー头像 -->
                        <img
                          :src="$store.state.sysInit.watson_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username ==
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            scope.row.isChatbot
                          "
                        />
                        <!-- もっぴー头像，分成两个img的目的是？ -->
                        <img
                          :src="$store.state.sysInit.watson_logo"
                          v-if="
                            scope.row.flag == 'left' &&
                            scope.row.username ==
                              $store.state.sysInit.html_const
                                .cons_266_moppy_name &&
                            !scope.row.isChatbot
                          "
                        />
                      </span>
                    </div>
                    <!-- 聊天内容 -->
                    <div class="user_msg">
                      <span>
                        <!-- 用户名 -->
                        <div
                          class="speaker"
                          v-if="
                            scope.row.userId ==
                              $store.state.sysInit.manualChatQuestionerId &&
                            scope.row.issueId ==
                              $store.state.sysInit.manualChatModeIssueId
                          "
                        >
                          {{ scope.row.username }}
                        </div>
                        <!-- 聊天内容 -->
                        <div
                          class="user_text"
                          v-if="
                            scope.row.userId ==
                              $store.state.sysInit.manualChatQuestionerId &&
                            scope.row.issueId ==
                              $store.state.sysInit.manualChatModeIssueId
                          "
                        >
                          <span
                            class="ql-editor"
                            v-html="scope.row.editorText || scope.row.text"
                            style="padding: 4px 0px"
                          >
                          </span>
                        </div>
                      </span>
                      <br />
                      <!-- 聊天时间（右侧） -->
                      <div
                        style="float: right; font-size: 12px"
                        v-if="
                          scope.row.userId ==
                            $store.state.sysInit.manualChatQuestionerId &&
                          scope.row.issueId ==
                            $store.state.sysInit.manualChatModeIssueId &&
                          scope.row.flag == 'left'
                        "
                      >
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                      <!-- 聊天时间（左侧） -->
                      <div
                        style="float: left; font-size: 12px"
                        v-if="
                          scope.row.userId ==
                            $store.state.sysInit.manualChatQuestionerId &&
                          scope.row.issueId ==
                            $store.state.sysInit.manualChatModeIssueId &&
                          scope.row.flag == 'right'
                        "
                      >
                        {{ scope.row.messageTime.replaceAll("-","/") }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </span>
        </span>
      </section>
      <!-- 发送消息区域 -->
      <div>
        <!-- 显示保留开始按钮 -->
        <span v-if="$store.state.sysInit.showHoldOnButton">
          <!-- 显示等待列表 -->
          <span v-if="$store.state.sysInit.manualChatShowWaitingListFlg">
            <div
              class="footer-box3"
              v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
            >
              <div
                style="width: 45px; height: 30px; text-align: center"
                v-show="$store.state.stt.recordAudioFlg"
              >
                <img
                  id="img"
                  src="../assets/img/mic.png"
                  style="
                    width: 30px;
                    height: 28px;
                    position: relative;
                    top: 5px;
                    cursor: pointer;
                  "
                />
              </div>
              <div
                style="width: 45px; height: 30px; text-align: center"
                v-show="!$store.state.stt.recordAudioFlg"
              >
                <img
                  id="img"
                  src="../assets/img/mic.png"
                  style="
                    width: 30px;
                    height: 28px;
                    position: relative;
                    top: 5px;
                    cursor: pointer;
                  "
                />
              </div>

              <div class="about">
                <div class="editor_container">
                  <quill-editor
                    v-model="$store.state.discovery.autoCompleteInputText"
                    ref="myQuillEditor"
                    id="myQuillEditor"
                    :options="editorOption"
                    :disabled="true"
                  >
                  </quill-editor>
                  <div class="images-area">
                      <div class="image-container" v-for="image in images" :key="image.id">
                        <div class="image-wrapper" :class="computeClassNameByUploadingStatus(image.status)">
                          <!-- 图片删除图标 -->
                          <span
                            class="action-icon delete"
                            @click="removeImage(image.id)"
                          >
                            <icon name="close_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传中图标 -->
                          <span
                            class="action-icon upload"
                          >
                            <icon name="loop_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传失败图标 -->
                          <span
                            class="action-icon error"
                          >
                            <icon name="error_white"  style="background-color: #f00;"></icon>
                          </span>
                          <el-image
                            :src="image.thumbnail"
                            :preview-src-list="[image.original]"
                            fit="contain"
                          >
                          </el-image>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div style="width: 45px; height: 30px; text-align: center">
                <img
                  id="img"
                  src="../assets/img/send.png"
                  style="
                    width: 30px;
                    height: 28px;
                    position: relative;
                    top: 5px;
                    cursor: pointer;
                  "
                />
              </div>
            </div>
          </span>
          <!-- 不显示等待列表 -->
          <span v-else>
            <!-- ? -->
            <div
              v-if="
                $store.state.sysInit.manualChatSendMessageFlg &&
                this.$store.state.sysInit.waitCloseIssueId.indexOf(
                  this.$store.state.sysInit.manualChatModeIssueId
                ) == -1
              "
            >
              <!-- CHAT模式 -->
              <div
                class="footer-box"
                v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
              >
                <div
                  style="width: 45px; height: 30px; text-align: center"
                  @click="recordAudio()"
                  v-show="$store.state.stt.recordAudioFlg"
                >
                  <img
                    id="img"
                    src="../assets/img/mic.png"
                    style="
                      width: 30px;
                      height: 28px;
                      position: relative;
                      top: 5px;
                      cursor: pointer;
                    "
                  />
                </div>
                <div
                  style="width: 45px; height: 30px; text-align: center"
                  @click="stopRecordAudio()"
                  v-show="!$store.state.stt.recordAudioFlg"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#FF0602"
                    style="
                      height: 28px;
                      width: 28px;
                      cursor: pointer;
                      animation-name: breath;
                      animation-duration: 2.5s;
                      animation-timing-function: ease-in-out;
                      animation-iteration-count: infinite;
                      -webkit-animation-name: breath;
                      -webkit-animation-duration: 2.5s;
                      -webkit-animation-timing-function: ease-in-out;
                      -webkit-animation-iteration-count: infinite;
                    "
                    class="icon icon breath_light"
                  >
                    <rect x="10" y="10" width="12" height="12"></rect>
                    <path
                      d="M15.6,2.1c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S23.3,2.1,15.6,2.1z M15.6,28.1 c-6.6,0-12-5.4-12-12s5.4-12,12-12s12,5.4,12,12S22.2,28.1,15.6,28.1z"
                    ></path>
                  </svg>
                </div>
                <div class="about">
                  <div class="editor_container">
                    <quill-editor
                      v-model="$store.state.discovery.autoCompleteInputText"
                      ref="myQuillEditor"
                      id="myQuillEditor"
                      :options="editorOption"
                      @focus="inputOn()"
                      @input="textChangeEvent()"
                      @paste.native.capture="pasteDescription($event)"
                    >
                    </quill-editor>
                    <div class="images-area">
                      <div class="image-container" v-for="image in images" :key="image.id">
                        <div class="image-wrapper" :class="computeClassNameByUploadingStatus(image.status)">
                          <!-- 图片删除图标 -->
                          <span
                            class="action-icon delete"
                            @click="removeImage(image.id)"
                          >
                            <icon name="close_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传中图标 -->
                          <span
                            class="action-icon upload"
                          >
                            <icon name="loop_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传失败图标 -->
                          <span
                            class="action-icon error"
                          >
                            <icon name="error_white"  style="background-color: #f00;"></icon>
                          </span>
                          <el-image
                            :src="image.thumbnail"
                            :preview-src-list="[image.original]"
                            fit="contain"
                          >
                          </el-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="width: 45px; height: 30px; text-align: center"
                  @click="sendMessage"
                >
                  <img
                    id="img"
                    src="../assets/img/send.png"
                    style="
                      width: 30px;
                      height: 28px;
                      position: relative;
                      top: 5px;
                      cursor: pointer;
                    "
                  />
                </div>
              </div>
            </div>

            <div v-else>
              <!-- CHAT模式 -->
              <div
                class="footer-box3"
                v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
              >
                <div
                  style="width: 45px; height: 30px; text-align: center"
                  v-show="$store.state.stt.recordAudioFlg"
                >
                  <img
                    id="img"
                    src="../assets/img/mic.png"
                    style="
                      width: 30px;
                      height: 28px;
                      position: relative;
                      top: 5px;
                      cursor: pointer;
                    "
                  />
                </div>
                <div
                  style="width: 45px; height: 30px; text-align: center"
                  v-show="!$store.state.stt.recordAudioFlg"
                >
                  <img
                    id="img"
                    src="../assets/img/mic.png"
                    style="
                      width: 30px;
                      height: 28px;
                      position: relative;
                      top: 5px;
                      cursor: pointer;
                    "
                  />
                </div>

                <div class="about">
                  <div class="editor_container">
                    <quill-editor
                      v-model="$store.state.discovery.autoCompleteInputText"
                      ref="myQuillEditor"
                      id="myQuillEditor"
                      :options="editorOption"
                      :disabled="true"
                    >
                    </quill-editor>
                    <div class="images-area">
                      <div class="image-container" v-for="image in images" :key="image.id">
                        <div class="image-wrapper" :class="computeClassNameByUploadingStatus(image.status)">
                          <!-- 图片删除图标 -->
                          <span
                            class="action-icon delete"
                            @click="removeImage(image.id)"
                          >
                            <icon name="close_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传中图标 -->
                          <span
                            class="action-icon upload"
                          >
                            <icon name="loop_white" style="background-color: #888;"></icon>
                          </span>
                          <!-- 图片上传失败图标 -->
                          <span
                            class="action-icon error"
                          >
                            <icon name="error_white"  style="background-color: #f00;"></icon>
                          </span>
                          <el-image
                            :src="image.thumbnail"
                            :preview-src-list="[image.original]"
                            fit="contain"
                          >
                          </el-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style="width: 45px; height: 30px; text-align: center">
                  <img
                    id="img"
                    src="../assets/img/send.png"
                    style="
                      width: 30px;
                      height: 28px;
                      position: relative;
                      top: 5px;
                      cursor: pointer;
                    "
                  />
                </div>
              </div>
            </div>
          </span>
        </span>
        <!-- 不显示保留开始按钮 -->
        <span v-else>
          <!-- CHAT模式 -->
          <div
            class="footer-box3"
            v-if="$store.state.sysInit.ws_mode === 'MANUAL_CHAT_MODE'"
          >
            <div
              style="width: 45px; height: 30px; text-align: center"
              v-show="$store.state.stt.recordAudioFlg"
            >
              <img
                id="img"
                src="../assets/img/mic.png"
                style="
                  width: 30px;
                  height: 28px;
                  position: relative;
                  top: 5px;
                  cursor: pointer;
                "
              />
            </div>
            <div
              style="width: 45px; height: 30px; text-align: center"
              v-show="!$store.state.stt.recordAudioFlg"
            >
              <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              fill="#FF0602"
              style="height: 28px; width: 28px; cursor: pointer"
              class="icon icon breath_light"
            >
              <rect x="10" y="10" width="12" height="12"></rect>
              <path
                d="M15.6,2.1c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S23.3,2.1,15.6,2.1z M15.6,28.1 c-6.6,0-12-5.4-12-12s5.4-12,12-12s12,5.4,12,12S22.2,28.1,15.6,28.1z"
              ></path>
            </svg> -->
              <img
                id="img"
                src="../assets/img/mic.png"
                style="
                  width: 30px;
                  height: 28px;
                  position: relative;
                  top: 5px;
                  cursor: pointer;
                "
              />
            </div>

            <div class="about">
              <div class="editor_container">
                <quill-editor
                  v-model="$store.state.discovery.autoCompleteInputText"
                  ref="myQuillEditor"
                  id="myQuillEditor"
                  :options="editorOption"
                  :disabled="true"
                >
                </quill-editor>
                <div class="images-area">
                  <div class="image-container" v-for="image in images" :key="image.id">
                    <div class="image-wrapper" :class="computeClassNameByUploadingStatus(image.status)">
                      <!-- 图片删除图标 -->
                      <span
                        class="action-icon delete"
                        @click="removeImage(image.id)"
                      >
                        <icon name="close_white" style="background-color: #888;"></icon>
                      </span>
                      <!-- 图片上传中图标 -->
                      <span
                        class="action-icon upload"
                      >
                        <icon name="loop_white" style="background-color: #888;"></icon>
                      </span>
                      <!-- 图片上传失败图标 -->
                      <span
                        class="action-icon error"
                      >
                        <icon name="error_white"  style="background-color: #f00;"></icon>
                      </span>
                      <el-image
                        :src="image.thumbnail"
                        :preview-src-list="[image.original]"
                        fit="contain"
                      >
                      </el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 45px; height: 30px; text-align: center">
              <img
                id="img"
                src="../assets/img/send.png"
                style="
                  width: 30px;
                  height: 28px;
                  position: relative;
                  top: 5px;
                  cursor: pointer;
                "
              />
            </div>
          </div>
        </span>
      </div>
    </el-card>
    <PiDialog
      v-if="$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE'"
    ></PiDialog>
    <ChatPiDialog></ChatPiDialog>
    <SvTalk></SvTalk>
    <SvOnSupport></SvOnSupport>
    <el-dialog
      :title="
        this.$store.state.sysInit.html_const.cons_220_confirm_stop_call_title
      "
      :visible.sync="$store.state.stt.dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <span
        v-html="
          this.$store.state.sysInit.html_const.cons_221_confirm_stop_call_msg
        "
      ></span>
      <span slot="footer" class="dialog-footer">
        <span v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'">
          <el-button @click="sttEnd" class="is-red" style="margin-right: 20px">
            {{
              this.$store.state.sysInit.html_const.cons_222_confirm_stop_ok
            }}</el-button
          >
        </span>
        <span v-else>
          <el-button @click="sttEnd" class="is-red" style="margin-right: 20px">
            {{
              this.$store.state.sysInit.html_const.cons_222_confirm_stop_ok
            }}</el-button
          >
        </span>

        <el-button
          @click="
            $store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE'
              ? ws_dialogControl()
              : dialogControl()
          "
          type="primary"
          plain
        >
          {{
            this.$store.state.sysInit.html_const.cons_223_confirm_stop_cancel
          }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="
        this.$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'
          ? this.$store.state.sysInit.html_const.cons_224_stop_call_title
          : this.$store.state.sysInit.html_const.cons_264_stop_chat_title
      "
      :visible.sync="$store.state.stt.dialogVisible2"
      :close-on-click-modal="false"
      @close="reload"
      class="dialog-data close-dialog"
      style="height: 100%; padding: 0"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <span slot="title" class="dialog-title">
        <span
          class="el-dialog__title"
          v-html="
            this.$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'
              ? this.$store.state.sysInit.html_const.cons_224_stop_call_title
              : this.$store.state.sysInit.html_const.cons_264_stop_chat_title
          "
        ></span>
        <span class="dialog-header-search">
          <el-input
            size="small"
            v-model="dialogSearchText"
            placeholder="入力してください"
            clearable
            class="dialog-search-input"
            @keyup.enter.native="searchDialogText"
          ></el-input>
          <el-button
            style="margin-left: 1%"
            type="info"
            class="dialog-search-nav-btn"
            icon="el-icon-caret-top"
            @click="dialogSearchPrev"
          ></el-button>
          <span class="dialog-search-count">{{ dialogSearchIndex }}/{{ dialogSearchTotal }}</span>
          <el-button
            type="info"
            class="dialog-search-nav-btn"
            icon="el-icon-caret-bottom"
            @click="dialogSearchNext"
          ></el-button>
        </span>
      </span>
      <!-- Block the end-call content until Dify finishes generating the title and next action. -->
      <div
        class="dialog-content-wrapper"
        v-loading="nextActionLoading"
      >
        <!-- 左侧边栏 -->
        <div class="dialog-left-sidebar">
          <!-- カテゴリ（IVR番号） -->
          <div class="left-sidebar-section">
            <div class="left-sidebar-section-title" @click="showCategorySection = !showCategorySection">
              <span>カテゴリ（IVR番号）</span>
              <i :class="showCategorySection ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="left-sidebar-section-content" v-if="showCategorySection">
              <div
                class="cate_type"
                v-for="item in keywordsArr"
                :key="item.key"
              >{{ item.key }}({{ item.count }})</div>
              <div v-if="keywordsArr.length === 0" class="left-sidebar-empty">なし</div>
            </div>
          </div>
          <div class="sidebar-divider"></div>
          <!-- サポート時間 -->
          <div class="left-sidebar-section">
            <div class="left-sidebar-section-title" @click="showSupportTimeSection = !showSupportTimeSection">
              <span>サポート時間</span>
              <i :class="showSupportTimeSection ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="left-sidebar-section-content" v-if="showSupportTimeSection">
              <div class="left-sidebar-small-text">
                {{ supportDate }}
              </div>
              <div class="left-sidebar-small-text">
                {{ "開始：" + startTime + "　〜　終了：" + endTime + callTime }}
              </div>
            </div>
          </div>
          <div class="sidebar-divider"></div>
          <!-- アラート通知（登場回数） -->
          <div class="left-sidebar-section">
            <div class="left-sidebar-section-title" @click="showAlertSection = !showAlertSection">
              <span>アラート通知（登場回数）</span>
              <i :class="showAlertSection ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <!-- <div class="left-sidebar-section-content" v-if="showAlertSection">
              <div class="left-sidebar-empty">なし</div>
            </div> -->
            <div class="detected-alerts" v-if="showAlertSection">
              <!-- <el-tag><span class="alert-sv el-tag-common">SVヘルプ (1)</span></el-tag> -->
              <el-tag key="warning" v-if="warningCount > 0">
                <span class="alert-warning-tag el-tag-common">{{ `要注意 (${warningCount})`}}</span>
              </el-tag>
              <el-tag key="longTime" v-if="isLongTime">
                <span class="alert-long-time el-tag-common">長時間</span>
              </el-tag>
              <el-tag key="wow" v-if="wowCount > 0">
                <span class="alert-wow el-tag-common">{{ `WOW (${wowCount})` }}</span>
              </el-tag>
              <el-tag key="ng" v-if="ngCount > 0">
                <span class="alert-ng el-tag-common">{{ `NG (${ngCount})` }}</span>
              </el-tag>
              <div v-if="warningCount === 0 && wowCount === 0 && ngCount === 0 && isLongTime === false" class="left-sidebar-empty">なし</div>
            </div>
          </div>
          <div class="sidebar-divider"></div>
          <!-- 評価ワード（登場回数） -->
          <div class="left-sidebar-section">
            <div class="left-sidebar-section-title" @click="showEvalWordSection = !showEvalWordSection">
              <span>評価ワード（登場回数）</span>
              <i :class="showEvalWordSection ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="eval-word-tags" v-if="showEvalWordSection">
              <template v-if="evalWordList.length > 0">
                <el-tag v-for="(tag, index) in evalWordList" :key="index">
                  <span
                    :class="[getEvalWordClass(tag.type), 'el-tag-common']"
                  >{{ `${tag.keyword} (${tag.count})` }}</span>
                </el-tag>
              </template>
              <div v-else class="left-sidebar-empty">なし</div>
            </div>
          </div>
          <div class="sidebar-divider"></div>
          <!-- ACW tag section -->
          <div class="left-sidebar-section">
            <div class="left-sidebar-section-title" @click="showAcwSection = !showAcwSection">
              <span>ACWタグ</span>
              <i :class="showAcwSection ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="detected-alerts" v-if="showAcwSection">
              <el-tag key="acwContant" v-if="acwContentFormatted && acwContentFormatted.length > 0">
                <span class="alert-acw-content el-tag-common">{{ acwContentFormatted}}</span>
              </el-tag>
              <div class="left-sidebar-small-text"></div>
            </div>
          </div>
        </div>
        <!-- 右侧内容区域 -->
        <div class="dialog-right-main">
          <!-- 通話者情報 -->
          <div class="dialog-user-info">
            <el-avatar class="dialog-user-avatar" :src="$store.state.sysInit.phone_questioner_logo || $store.state.sysInit.questioner_logo"></el-avatar>
            <span class="dialog-user-name">{{ $store.state.sysInit.phone_questioner_name || 'お問い合わせ者' }}</span>
            <span class="dialog-user-separator">と</span>
            <el-avatar class="dialog-user-avatar" :src="$store.state.sysInit.ws_mode === 'STAND_MIC_MODE' ? $store.state.sysInit.operator_logo_f2f : $store.state.sysInit.operator_logo"></el-avatar>
            <span class="dialog-user-name">{{ $store.state.sysInit.user_name || 'オペレーター' }} の通話</span>
          </div>
          <!-- タイトル -->
          <div class="dialog-subject-section">
            <p style="margin-bottom: 5px;">
              {{ this.$store.state.sysInit.html_const.cons_228_subject }}
            </p>
            <el-input
              size="mini"
              class="search-input"
              style="margin-bottom: 10px"
              v-model="$store.state.stt.title"
              :placeholder="this.$store.state.sysInit.html_const.cons_228_subject"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="clearInput"
                v-if="this.$store.state.stt.title !== ''"
              ></i>
            </el-input>
          </div>
          <!-- Full text, edited text, and next action -->
          <div class="all-text-and-edited-text">
            <!-- Full text -->
            <div :span="10" class="all-text-area">
              <div class="copy-all-row">
                <span>全文テキスト</span>
                <span class="dialog-footer-btn-area">
                  <el-tooltip effect="dark" :content="this.$store.state.sysInit.html_const.cons_233_gpt_conversation" placement="top">
                    <div class="footer_btn" :class="isGPTLoading ? 'footer_btn_disabled' : ''" @click="sendGPT(1)">
                      <img class="footer_btn_icon" src="../assets/img/footer_btn1.png" alt="">
                    </div>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="this.$store.state.sysInit.html_const.cons_234_gpt_no_conversation" placement="top">
                    <div class="footer_btn" :class="isGPTLoading ? 'footer_btn_disabled' : ''" @click="sendGPT(2)">
                      <img class="footer_btn_icon" src="../assets/img/footer_btn2.png" alt="">
                    </div>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="this.$store.state.sysInit.html_const.cons_229_copy_bookmark_text" placement="top">
                    <div class="footer_btn" @click="movePart">
                      <img class="footer_btn_icon" src="../assets/img/footer_btn3.png" alt="">
                    </div>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="this.$store.state.sysInit.html_const.cons_230_copy_all_text" placement="top">
                    <div class="footer_btn" @click="moveAll">
                      <img class="footer_btn_icon" src="../assets/img/footer_btn4.png" alt="">
                    </div>
                  </el-tooltip>
                </span>
              </div>
              <div class="all-text-container">
                <el-table
                  :data="sttNotesTotal"
                  ref="multipleTable2"
                  :show-header="false"
                  height="520"
                  :empty-text="
                    this.$store.state.sysInit.html_const.cons_219_no_data
                  "
                  class="dialog_table table-border"
                  :cell-style="cellStyle_table"
                >
                  <el-table-column>
                    <template slot-scope="scope">
                      <div class="dialog-sentence-row">
                        <div class="dialog-sentence-avatar">
                          <el-avatar
                            :size="22"
                            :src="getDialogAvatarSrc(scope.row)"
                          ></el-avatar>
                        </div>
                        <div class="dialog-sentence-content" :class="scope.row.heart_flag == 1 ? 'heart-row' : ''">
                          <span v-html="highlightKeywords(scope.row.editorText || scope.row.text, scope.$index)"></span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- Edited text -->
            <div :span="10" class="edited-text-area">
              <div class="copy-all-row">
                <span>編集後テキスト</span>
                <span class="dialog-footer-btn-area">
                  <el-tooltip effect="dark" :content="this.$store.state.sysInit.html_const.cons_231_copy_edited_text" placement="top">
                    <div class="footer_btn" @click="copyPart">
                      <img class="footer_btn_icon" src="../assets/img/footer_btn4.png" alt="">
                    </div>
                  </el-tooltip>
                </span>
              </div>
              <div class="edited-text-container">
                <el-input
                  style="height: 520px"
                  type="textarea"
                  resize="none"
                  :rows="11"
                  placeholder=""
                  v-model="$store.state.stt.sttNotesCopy"
                  v-loading="isGPTLoading"
                  v-show="!dialogSearchText"
                >
                </el-input>
                <div
                  v-show="dialogSearchText"
                  class="edited-text-highlight-overlay"
                  v-html="highlightEditedText($store.state.stt.sttNotesCopy)"
                ></div>
              </div>
            </div>
            <!-- Next action -->
            <div :span="10" class="next-action-area">
              <div class="copy-all-row">
                <span>ネクストアクション</span>
              </div>
              <div class="next-action-container">
                <div class="next-action-content" v-if="nextActionText">
                  <!-- Render numbered next actions as an indented list when Dify returns list-style text. -->
                  <ol v-if="nextActionItems.length" class="next-action-list">
                    <li v-for="(item, index) in nextActionItems" :key="index">
                      {{ item }}
                    </li>
                  </ol>
                  <div v-else>{{ nextActionText }}</div>
                </div>
                <div class="next-action-empty" v-else>
                  {{ nextActionError || '通話終了後に自動生成されます。' }}
                </div>
              </div>
            </div>
          </div>
          <!-- 起票按钮 -->
          <div style="display: flex;justify-content: center;">
            <div :span="10" class="action" >
              <!-- Ticket actions use a shared layout so every button keeps the same width and two-line label. -->
              <el-button
                size="medium"
                class="ticket-action-btn currentActionSolved"
                @click="handleActionClick('SOLVED')"
              >
                <span class="ticket-action-label">
                  <span>解決</span>
                  <span>(SOLVED)</span>
                </span>
              </el-button>
              <el-button
                size="medium"
                class="ticket-action-btn currentActionOnGoing"
                @click="handleActionClick('ON GOING')"
              >
                <span class="ticket-action-label">
                  <span>継続</span>
                  <span>(ON GOING)</span>
                </span>
              </el-button>  
              <el-button
                size="medium"
                class="ticket-action-btn currentActionUnSolved"
                @click="handleActionClick('UNSOLVED')"
              >
                <span class="ticket-action-label">
                  <span>エスカレーション</span>
                  <span>(UNSOLVED)</span>
                </span>
              </el-button>
            </div>
            <!-- ESCALATION -->
            <!-- <div class="flag" >
              <el-checkbox
                v-model="checked"
                style="padding-top: 16px; margin-left: 10px;"
                @change="changeEscalation"
              >
                <span>ESCALATION</span>
              </el-checkbox>
            </div> -->
          </div>
        </div>
      </div>
    </el-dialog>
  </el-aside>
</template>

<script>
import api from "@/api";
import ArraryOperation from "@/utils";
import VueUtils from '@/utils/utils.js'
import { mapGetters, mapMutations } from "vuex";
import {
  orderBy,
  findIndex,
  reverse,
  sortBy,
  toPairs,
  find,
  chunk,
  remove,
  omit,
  cloneDeep,
} from "lodash";
import moment from "moment";
import { Message } from "element-ui";
// import MySlider from "./MySlider.vue";
import PiDialog from "./PiDialog.vue";
import ChatPiDialog from "./PiChatDialog.vue";
import SvTalk from "./SvTalk.vue";
import SvOnSupport from "./SvOnSupport.vue";
import CallStartButton from "./CallStartButton.vue";
import ManualChatButton from "./ManualChatButton.vue";
import HoldStartButton from "./HoldStartButton.vue";
import ManualChatInput from "./ManualChatInput.vue";
import NavigationText from "./NavigationText.vue";
import { quillEditor, Quill } from "vue-quill-editor";
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import AzureSpeech from "@/utils/azure-speech.js"

// var stream = "";

// var chatConfig = {
//   access_token: "", // Authorization sttToken to use this service, configured from /speech/stt-sttToken.js file
//   continuous: true, // False = automatically stop transcription the first time a pause is detected
//   // outputElement: document.getElementById('autoInput'), // CSS selector or DOM Element
//   inactivity_timeout: -1, // Number of seconds to wait before closing input stream
//   format: true, // Inhibits errors
//   keepMicrophone: false, // Avoids repeated permissions prompts in FireFox
//   model: "ja-JP_NarrowbandModel",
//   // language_customization_id: sttCustomizationId,
//   url: "https://api.jp-tok.speech-to-text.watson.cloud.ibm.com/instances/7a6942da-f73e-4894-aa66-39bb6c00b52d",
//   language_customization_id: "",
// };
// import sysInit from '../store/modules/sysInit'
export default {
  components: {
    // MySlider,
    PiDialog,
    ChatPiDialog,
    SvTalk,
    SvOnSupport,
    CallStartButton,
    ManualChatButton,
    HoldStartButton,
    ManualChatInput,
    NavigationText,
    quillEditor,
  },
  props: {},
  data() {
    return {
      longTimeConfig: 2,
      currentAction: 'ON GOING',
      isGPTLoading: false,
      noData: true,
      // showImmediately: false,
      // this.$store.state.stt.dialogVisible: false,
      // this.$store.state.stt.dialogVisible2: false,
      // this.$store.state.stt.dialogVisible3: false,
      multipleSelection: [],
      // 打开开关的聊天记录
      searchData: [],
      searchIndex: 0,
      likeData: [],
      currentId: "",

      // this.$store.state.stt.stopStatus: "info",
      // this.$store.state.stt.scrollStatus: "info",
      scrollIcon: "pause",
      // this.$store.state.stt.scrollFlag: true,
      // this.$store.state.stt.isMouse: false,

      editAndSaveFlag: true,
      editAndSaveStatus: true,

      pollingChatTimer: "",

      sttNotesTotal: [],
      // sttStartTime: "",
      // $store.state.stt.sttEndTime: "",
      // startTime: "",
      // endTime: "",
      // telTime: "",
      keywordsArr: [],
      // loadings:[],

      isEditable: false,
      // title: "",
      // $store.state.stt.isDisabl: false,
      emptyTextStatus: "",
      aside_width: "40%",
      dialogTableVisible: false,

      // escalation_flag:null,
      // timer: '',
      // btn_type: "info",
      // turnMicStart_title:'',
      // ws_start_button:"info",
      // isPause: false,
      // end_btn:false,
      manualChatText: [],
      manualChatCurrentUserId: "",
      dropdownList: ["ON GOING", "UNSOLVED", "SOLVED"],
      // dropdownText:"",
      operatorBtn: true,
      questionBtn: true,
      records: [],

      inputText: "",
      autoInputHolder: "",
      onInputFlg: "",
      content: "",
      texts: "",
      // 编辑器配置
      editorOption: {
        placeholder: "回答を入力してください",
        modules: {
           /* 2023/1/23 仕様変更：JAL‐Demo : add start */
          clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.handlePaste]]
          },
           /* 2023/1/23 仕様変更：JAL‐Demo : add end */
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], //  加粗、倾斜、下划线、删除线 !
              // ['blockquote', 'code-block'],// 引用代码块 !
              // [{'header': 1}, {'header': 2}], // 标题，键值对应的形式，1，2 表示字体大小 !
              // [{'list': 'ordered'}, {'list': 'bullet'}], // 列表
              [{ script: "sub" }, { script: "super" }], // 上下标 !
              // [{'indent': -1}, {'indent': +1}], // 缩进 !
              // [{'direction': 'rtl'}], // 文本方向
              // [{'size': ['small', false, 'large', 'huge']}], // 字体大小
              // [{'header': [1, 2, 3, 4, 5, 6, false]}], // 几级标题
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色 !
              // [{'font': []}], // 字体
              // [{'align': []}], // 对齐方式
              ["clean"], //清除
              // ['image', 'video'], // 上传图片、上传视频
              ['image'],
            ],
            handlers: {
              'image': this.handleImageSelect,
            },
          },
          imageDropAndPaste: {
            handler: this.handleImageDropAndPaste,
          },
        },
      },
      // 待发送图片列表
      // 此处为原始的图片列表数据
      // 函数和UI中请使用计算属性images
      images: [],
      // 当前时间，用于计算通话时长
      currentTime: null,
      // 定时器ID，用于更新当前时间
      durationTimer: null,
      // 终了Dialog左侧栏折叠状态
      showCategorySection: true,
      showSupportTimeSection: true,
      showAlertSection: true,
      showEvalWordSection: true,
      showAcwSection: true,
      // 终了Dialog検索テキスト
      dialogSearchText: '',
      // 终了Dialog検索結果
      dialogSearchMatches: [],
      dialogSearchCurrentIndex: 0,
      // 终了Dialog全マッチリスト（全文テキスト＋編集後テキスト）
      dialogSearchAllMatches: [],
      // Auto-generated ACW and next action for end dialog
      acwContent: '',
      nextActionText: '',
      nextActionLoading: false,
      nextActionError: '',
    };
  },
  watch: {
    sttNotes: {
      handler(newVal, oldVal) {
        if (this.$store.state.stt.isScroll) {
          setTimeout(() => {
            this.onScroll();
          }, 500);
        }
      },
      deep: true,
      immediate: true,
    },

    "$store.state.sysInit.talkStatus": function () {
      if (this.$store.state.sysInit.talkStatus === "start") {
        this.$store.state.stt.isScroll = true;
        this.$store.state.sysInit.modeFlag = false;
        this.$store.state.sysInit.ws_start_button = "primary";
      }

      if (this.$store.state.sysInit.talkStatus === "end") {
        this.stopDurationTimer();
        this.$store.dispatch("stt/turnMicOff");
        this.$store.dispatch(
          "sysInit/changerTurnMicStartTitle",
          this.$store.state.sysInit.ws_mode
        );
        this.$store.dispatch("stt/turnMicEnd");
        this.$store.state.stt.isScroll = false;
        this.$store.state.stt.isMouse = false;
        // this.end_btn = true;
        this.$store.state.stt.isMicPause = false;
        this.$store.state.sysInit.modeFlag = false;
        // this.$store.state.stt.isMicOn = false;
        // this.btn_type = "info";
        // this.$store.state.stt.dialogVisible = true;//

        // 相手側が電話を切った場合も、「サポート終了です。お疲れ様です。」画面を自動表示する
        // dialogVisible2 が既に true の場合は、ユーザーが「サポート終了」→OKで既に発火済みのためスキップ
        if (
          this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE" &&
          !this.$store.state.stt.dialogVisible2
        ) {
          this.$store.state.stt.dialogVisible = false;
          this.sttEnd();
        }
      }
    },
    "$store.state.sysInit.phonenum": function () {
      console.log(
        "this.$store.state.sysInit.phonenum",
        this.$store.state.sysInit.phonenum
      );
      // this.piAnalyze(this.$store.state.sysInit.phonenum);
    },
    // '$store.state.sysInit.op_answered': function(val) {
    //   if (val == true && this.$store.state.stt.isMicOn == false
    //     && (window.AudioContext || window.webkitAudioContext)) {
    //     // ブラウザセキュリティー上の制約があるため、AudioContextが取れる場合のみ「通話開始」へ自動切り替えさせる
    //     let AudioContext = window.AudioContext || window.webkitAudioContext;
    //     let testAudioContext = new AudioContext();
    //     if (testAudioContext.state == 'running') {
    //       this.$refs.turnMicStart.$el.click();
    //     } else {
    //       console.log('mic can not be turned on auto');
    //     }
    //   }
    // }
    // "this.$store.state.stt.dialogVisible": function () {
    //   if (
    //     this.$store.state.sysInit.talkStatus === "end" &&
    //     this.$store.state.stt.dialogVisible === true
    //   ) {
    //   }
    // },
    "$store.state.sysInit.manualChatMessageList": {
      handler(newVal, oldVal) {
        if (this.$store.state.stt.isScroll) {
          setTimeout(() => {
            this.onScroll();
          }, 500);
        }
      },
    },

    "$store.state.sysInit.manualChatSendMessageFlg": function () {
      //        this.$nextTick(() => {
      //         // this.$refs.autoInput.handleBlur();
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },
    "$store.state.sysInit.writingFlg": function () {
      //        this.$nextTick(() => {
      //         // this.$refs.autoInput.handleBlur();
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    "$store.state.sysInit.chat_current_status": function () {
      //         this.$nextTick(() => {
      //         // this.$refs.autoInput.handleBlur();
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },
    "$store.state.sysInit.manualChatQuestionerId": function () {
      //         this.$nextTick(() => {
      //         // this.$refs.autoInput.handleBlur();
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    "$store.state.sysInit.manualChatUserCount": function () {
      //         this.$nextTick(() => {
      //         // this.$refs.autoInput.handleBlur();
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    // "this.$store.state.sysInit.manualChatMessageList":function(){
    //   this.manualChatText = this.$store.state.sysInit.manualChatMessageList;
    // }

    "$store.state.discovery.copyCounter": function () {
      this.$nextTick(() => {
        // this.$refs.myQuillEditor.handleBlur()
      });
    },
    // 検索テキストが変更された時に検索結果をリセット
    dialogSearchText(newVal) {
      // テキストが変更されたら検索結果をリセットして再構築
      this.dialogSearchAllMatches = [];
      this.dialogSearchMatches = [];
      this.dialogSearchCurrentIndex = 0;
      if (newVal) {
        this.buildSearchMatches();
      }
    },
    // 为了获取图片列表变化前的状态，监听计算属性而不是原始的图片列表，否则newVal和oldVal取到的都是图片列表的引用值
    computedImages: {
      handler(newVal, oldVal) {
        // 第一次新增图片或删除掉所有图片后触发滚动
        if (newVal.length + oldVal.length === 1) {
          setTimeout(() => {
            this.onScroll();
          }, 500);
        }
      }
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    ...mapGetters("discovery", {
      collections: "getCollections",
    }),
    ...mapGetters("stt", {
      sttNotes: "getSttNotes",
    }),
    computedImages() {
      return JSON.parse(JSON.stringify(this.images));
    },
    dialogSearchIndex() {
      if (this.dialogSearchAllMatches.length === 0) return 0;
      return this.dialogSearchCurrentIndex + 1;
    },
    dialogSearchTotal() {
      return this.dialogSearchAllMatches.length;
    },
    nextActionItems() {
      const text = this.nextActionText || "";
      const lines = text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);

      // Only convert when every non-empty line follows the numbered-list format.
      const items = lines
        .map((line) => {
          const match = line.match(/^\d+[.)]\s*(.+)$/);
          return match ? match[1].trim() : "";
        })
        .filter(Boolean);

      return items.length === lines.length ? items : [];
    },
    supportDate() {
      return this.$store.state.stt.sttStartTime
        ? this.$store.state.stt.sttStartTime.substr(0, 10)
        : "";
    },
    startTime() {
      return this.$store.state.stt.sttStartTime
        ? this.$store.state.stt.sttStartTime.substr(11, 5)
        : "";
    },
    endTime() {
      return this.$store.state.stt.sttEndTime
        ? this.$store.state.stt.sttEndTime.substr(11, 5)
        : "";
    },
    callTime() {
      console.log('this.$store.state.stt.wordList', this.$store.state.stt.wordList)
      console.log('this.$store.state.sysInit', this.$store.state.sysInit)
      console.log('this.$store.state.stt', this.$store.state.stt)

      const duration = moment.duration(
        moment(this.$store.state.stt.sttEndTime, "YYYY-MM-DD HH:mm:ss").diff(
          moment(this.$store.state.stt.sttStartTime, "YYYY-MM-DD HH:mm:ss")
        )
      );
      let minutes = `${parseInt(duration.asMinutes())}`;
      let seconds = `${parseInt(duration.seconds())}`;
      return (
        " （" +
        (minutes > 0 ? `${minutes}分` : "") +
        (seconds > 0 ? `${seconds}秒` : "") +
        "）"
      );
    },
    // wordListを正規化（カンマ区切りのkeywordを分割して個別にカウント）
    normalizedWordList() {
      const wordList = this.$store.state.stt.wordList || [];
      const result = [];
      wordList.forEach(item => {
        if (item.keyword && item.keyword.includes(',')) {
          const keywords = item.keyword.split(',').map(k => k.trim()).filter(k => k);
          keywords.forEach(kw => {
            result.push({ ...item, keyword: kw });
          });
        } else {
          result.push(item);
        }
      });
      return result;
    },
    warningCount() {
      return this.normalizedWordList.filter(item => item.type === 'warning').length;
    },
    wowCount() {
      return this.normalizedWordList.filter(item => item.type === 'wow').length;
    },
    ngCount() {
      return this.normalizedWordList.filter(item => item.type === 'ng').length;
    },
    evalWordList() {
      const keywordMap = {};
      this.normalizedWordList.forEach(item => {
        const key = `${item.keyword}_${item.type}`;
        if (!keywordMap[key]) {
          keywordMap[key] = { keyword: item.keyword, type: item.type, count: 0 };
        }
        keywordMap[key].count++;
      });
      return Object.values(keywordMap);
    },
    isLongTime() {
      if (!this.callDuration || this.callDuration === '00:00:00') {
        return false;
      }
      const parts = this.callDuration.split(':');
      const totalSeconds = parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
      // longTimeConfig单位为分钟，从后台LONG_TIME_CALL配置读取，默认2分钟
      return totalSeconds >= this.longTimeConfig * 60;
    },
    callDuration() {
      if (!this.$store.state.stt.startTime || !this.currentTime) {
        return '00:00:00';
      }
      
      // 解析开始时间（格式：HH:mm:ss）
      const startTimeParts = this.$store.state.stt.startTime.split(':');
      const startHours = parseInt(startTimeParts[0]);
      const startMinutes = parseInt(startTimeParts[1]);
      const startSeconds = parseInt(startTimeParts[2]);
      
      // 解析当前时间（格式：HH:mm:ss）
      const currentTimeParts = this.currentTime.split(':');
      const currentHours = parseInt(currentTimeParts[0]);
      const currentMinutes = parseInt(currentTimeParts[1]);
      const currentSeconds = parseInt(currentTimeParts[2]);
      
      // 转换为总秒数
      const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
      const currentTotalSeconds = currentHours * 3600 + currentMinutes * 60 + currentSeconds;
      
      // 计算时长（秒）
      let durationSeconds = currentTotalSeconds - startTotalSeconds;
      
      // 处理跨天的情况
      if (durationSeconds < 0) {
        durationSeconds += 24 * 3600;
      }
      
      // 转换为 HH:MM:SS 格式
      const hours = Math.floor(durationSeconds / 3600);
      const minutes = Math.floor((durationSeconds % 3600) / 60);
      const seconds = durationSeconds % 60;
      
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    acwContentFormatted() {
      return this.acwContent =='自己解決'? '' : this.acwContent;
    }
  },
  methods: {
    // 注册Quill模块
    registerQuillModules() {
      // 图片拖拽和粘贴
      Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
    },
    // テキスト編集バーの貼り付け
    handlePaste(node, delta) {
      console.log('delta', delta)
      /**
      delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          // 貼り付け文字の背景色を消す
          if (op.attributes && op.attributes.hasOwnProperty("background")) {
            op.attributes.background = "transparent"
          }
          // リンクのスタイルを設定
          if (op.attributes && op.attributes.hasOwnProperty("link")) {
            op.attributes.color = "#039be5",
            op.attributes.underline = true,
            op.attributes.bold= false
          }
        }
        if (op.insert && typeof op.insert.image) {
          const src = op.insert.image;
          let image = new Image();
          image.src = src;
          image.onload = () => {
            console.log('image.crossOrigin', image.crossOrigin)
            // 添加到待发送图片列表
            let newImage = {
              id: crypto.randomUUID(),                                 // UUID
              uploading: true,                                         // 上传状态
              thumbnail: VueUtils.generateThumbnail(image, 100, 100),  // 缩略图
              original: src,                                           // 原图
              url: "",                                                 // Object Storage中的存储地址
            }
            this.images.push(newImage);

            // 上传到Object Storage
            let data = new FormData();
            data.set('image', image);
            api.uploadChatImage({data}).then(res => {
              newImage.url = res.data.data.image;
              newImage.uploading = false;
            })
          }
          delta.ops = [];
        }
      }); */
      return delta;
    },
    // 处理图片选择
    handleImageSelect() {
      let input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
              // 新增待发送的图片
              this.addImage(reader.result, file);
            }
          }
        }
      }
    },
    // 处理图片拖拽和粘贴
    handleImageDropAndPaste(imageDataUrl, type, imageData) {
      this.addImage(imageDataUrl, imageData.toFile());
    },
    // 新增待发送的图片
    addImage(imageText, imageFile) {
      // 添加到待发送的图片列表
      let newImage = {
        id: crypto.randomUUID(),                                 // UUID
        status: 'uploading',                                     // 上传状态
        thumbnail: imageText,                                    // 缩略图
        original: imageText,                                     // 原图
        url: "",                                                 // Object Storage中的存储地址
      }
      this.images.push(newImage);

      // 上传到Object Storage
      let data = new FormData();
      data.append('image', imageFile);
      api.uploadChatImage(data)
        .then(res => {
          // 图片预加载
          let image = new Image();
          image.src = res.data.data.url;
          image.onload = () => {
            // 把图片预加载成功当作整个上传成功
            newImage.url = res.data.data.url;
            newImage.status = 'succeed';
          }
        })
        .catch(err => {
          newImage.status = 'failed';
        })
    },
    // 删除待发送的图片
    removeImage(id) {
      let image = this.images.find(i => i.id === id);
      // 删除缩略图
      this.images = this.images.filter(i => i.id !== id);
      // 删除Object Storage中存储的图片
      // 只删除上传成功的图片
      if (image && image.status === 'succeed') {
        api.removeChatImage({url: image.url});
      }
    },
    // 发送消息
    sendMessage() {
      // 停止录音
      this.stopRecordAudio();

      if (this.canSendMessage()) {
        // 富文本
        let richTextWithoutImages = this.$refs.myQuillEditor.value;
        let richText = richTextWithoutImages;
        if (this.images.length) {
          richText += this.createImageHtmlElements();
        }
        // 纯文本
        let rawText = document.getElementById("myQuillEditor").textContent.trim();
        this.$store.state.discovery.editorText = rawText;

        this.doSendMessage({richText, rawText});
      }
    },
    // 检查能否发送消息
    canSendMessage() {
      // Customer ID和Issue ID存在
      if (
        this.$store.state.sysInit.manualChatQuestionerId &&
        this.$store.state.sysInit.manualChatModeIssueId
      ) {
        // 去除首尾空白字符的富文本
        let richText = VueUtils.trimBlankChars(this.$refs.myQuillEditor.value);
        // 可以发送的图片列表
        let unsuccessfuleAttachments = this.images.filter(image => image.status !== 'succeed');
        if (!(richText || this.images.length) || (this.images.length && unsuccessfuleAttachments.length)) {
          return false;
        }
      }
      return true;
    },
    // 重置编辑器
    resetEditor() {
      // 清空富文本
      this.$store.state.discovery.autoCompleteInputText = '';
      // 清空图片
      if (this.images.length) {
        this.images = [];
      }
    },
    // 根据图片上传状态计算类名
    computeClassNameByUploadingStatus(status) {
      let classMapping = {
        uploading: 'status-uploading',
        succeed: 'status-succeed',
        failed: 'status-failed',
      }
      return classMapping[status];
    },
    // 创建图片展示用的HTML元素
    createImageHtmlElements() {
      let imagesHtmlElements = '';
      let styleOfImage = 'max-width: 100%;';
      for (let image of this.images) {
        imagesHtmlElements += `<div><img style="${styleOfImage}" src="${image.url}"></div>`;
      }
      let htmlElements = `<div>${imagesHtmlElements}<div/>`;
      return htmlElements;
    },

    /* 2023/1/23 仕様変更：JAL‐Demo : add end */

    changeEscalation() {
      this.$store.dispatch("redmine/updateEscalation", {
        escalation: this.checked ? 1 : 0,
      });
    },

    changeIssueStauts(command) {
      if (command == "ON GOING") {
        this.$store.state.sysInit.issue_Status = "1";
        this.$store.state.sysInit.dropdownText = "ON GOING";
      } else if (command == "UNSOLVED") {
        this.$store.state.sysInit.issue_Status = "41";
        this.$store.state.sysInit.dropdownText = "UNSOLVED";
      } else if (command == "SOLVED") {
        this.$store.state.sysInit.issue_Status = "4";
        this.$store.state.sysInit.dropdownText = "SOLVED";
      }

      // this.$store.dispatch("redmine/updateIssueStatus",{
      //   status:status
      // });
    },

    turnMicEnd() {
      if (this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
        // if (this.$store.state.stt.dialogVisible === false) {
        this.$store.state.stt.isScroll = false;
        this.$store.state.stt.isMouse = false;
        this.$store.state.stt.dialogVisible = true; //

        this.$store.commit("stt/changeMicStatus", { isMicOn: true });
      } else {
        this.$store.state.stt.isScroll = false;
        this.$store.state.stt.isMouse = false;

        this.$store.state.stt.dialogVisible = true; //
      }
    },
    sttEnd() {
      // 停止通话时长计时器
      this.stopDurationTimer();
      
      if (this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE") {
        this.$store.state.sysInit.turnMicStart_title =
          this.$store.state.sysInit.html_const.cons_205_start;
        this.$store.state.sysInit.ws_start_button = "primary";
        this.$store.state.sysInit.modeFlag = true;
        this.$store.state.stt.isMicOn = false;
        this.$store.dispatch("stt/turnMicEnd");
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
      ) {
        // OKボタン押下時に実際の通話終了処理を実行する
        this.$SIP.ToggleDoNoDisturb(true);
        this.$SIP.endSession(this.$store.state.phone.currentCallerNum);
        this.$store.state.sysInit.talkStatus = '';
        this.$store.state.stt.isScroll = false;
        this.$store.state.stt.isMouse = false;
        this.$store.commit("stt/changeMicStatus", { isMicOn: true });
        this.$store.state.sysInit.turnMicStart_title =
          this.$store.state.sysInit.html_const.cons_205_start;
        this.$store.state.sysInit.ws_start_button = "primary";
        this.$store.state.stt.isMicOn = false;
        this.$store.state.sysInit.modeFlag = true;
      }
      if (this.$store.state.sysInit.ws_mode !== "NEXMO_ASTERISK_PBX_MODE") {
        this.$store.state.stt.sttEndTime = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
      }
      
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        this.$store.dispatch("sysInit/closeManualChat");
        this.$store.state.stt.sttEndTime = moment(
          this.$store.state.stt.sttEndTime
        )
          .format("YYYY-MM-DD HH:mm:ss");

        let tempId = this.$store.state.sysInit.manualChatModeIssueId;
        let tempTime = _.find(
          this.$store.state.sysInit.manualChatStartTimeList,
          function (o) {
            return o.issueId == tempId;
          }
        );
        console.log("tempTime", tempTime);

        //////
        if (tempTime) {
          this.$store.state.stt.telTime =
            parseInt(
              moment(this.$store.state.stt.sttEndTime).diff(
                moment(tempTime.manualChatStartTime)
              ) / 60000
            ) + 1;
          this.$store.state.stt.startTime = moment(
            tempTime.manualChatStartTime
          ).format("HH:mm:ss");
        } else {
          this.$store.state.stt.telTime =
            parseInt(
              moment(this.$store.state.stt.sttEndTime).diff(
                moment(this.$store.state.stt.sttEndTime)
              ) / 60000
            ) + 1;
          this.$store.state.stt.startTime = moment(
            this.$store.state.stt.sttEndTime
          ).format("HH:mm:ss");
        }

        // if(){
        //   this.$store.state.sysInit.manualChatQuestionerId
        // }
        console.log(
          "this.$store.state.stt.startTime",
          this.$store.state.stt.startTime
        );
      } else {
        this.$store.state.stt.telTime =
          parseInt(
            moment(this.$store.state.stt.sttEndTime).diff(
              moment(this.$store.state.stt.sttStartTime)
            ) / 60000
          ) + 1;
        this.$store.state.stt.startTime = moment(
          this.$store.state.stt.sttStartTime
        ).format("HH:mm:ss");
      }

      this.$store.state.stt.endTime = moment(
        this.$store.state.stt.sttEndTime
      ).format("HH:mm:ss");
      console.log("this.sttNotes", this.sttNotes);

      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        //
        this.$store.state.sysInit.manualChatPiStatusText = "待機中";
        let singleMessageList = [];
        for (
          let i = 0;
          i < this.$store.state.sysInit.manualChatMessageList.length;
          i++
        ) {
          if (
            this.$store.state.sysInit.manualChatMessageList[i].userId ===
              this.$store.state.sysInit.manualChatQuestionerId &&
            this.$store.state.sysInit.manualChatMessageList[i].issueId ==
              this.$store.state.sysInit.manualChatModeIssueId
          ) {
            singleMessageList.push(this.$store.state.sysInit.manualChatMessageList[i]);
          }
        }
        let singleMultipleSelection = [];
        if (this.multipleSelection.length > 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (
              this.multipleSelection[i].userId ===
                this.$store.state.sysInit.manualChatQuestionerId &&
              this.multipleSelection[i].issueId ==
                this.$store.state.sysInit.manualChatModeIssueId
            ) {
              singleMultipleSelection.push(this.multipleSelection[i]);
            }
          }
        }

        singleMessageList.forEach((v) => {
          const note = find(singleMultipleSelection, { id: v.id });
          if (note) {
            this.sttNotesTotal.push({ ...v, heart_flag: 1 });
          } else {
            this.sttNotesTotal.push({ ...v, heart_flag: 0 });
          }
        });
      } else {
        this.sttNotes.forEach((v) => {
          const note = find(this.multipleSelection, { id: v.id });
          if (note) {
            this.sttNotesTotal.push({ ...v, heart_flag: 1 });
          } else {
            this.sttNotesTotal.push({ ...v, heart_flag: 0 });
          }
        });
      }

      this.$store.state.stt.dialogVisible = false;
      this.$store.state.stt.dialogVisible2 = true;
      if (this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
        this.generateAcwAndNextAction();
      }

      // this.$store.dispatch("stt/turnMicEnd");
      this.$store.state.stt.stopStatus = "info";
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        this.$store.state.stt.wordList = [];
        this.$store.commit("sysInit/changeNavigationText", 'ng/clear:');
        // this.$store.commit("sysInit/changeNavigationText", "");
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
      ) {
        if (this.$store.state.sysInit.call_error_finished) {
          this.$store.commit("sysInit/changeNavigationText", "");
        } else {
          this.$store.commit(
            "sysInit/changeNavigationText",
            this.$store.state.sysInit.html_const.cons_238_footer_stop_button
          );
        }
      } else if (this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE") {
        this.$store.commit(
          "sysInit/changeNavigationText",
          this.$store.state.sysInit.html_const.cons_238_footer_stop_button
        );
      }

      this.$store.state.stt.isScroll = false;
      this.$store.state.stt.isMouse = false;

      this.keywordsArr = [];
      console.log(
        "this.$store.state.stt.keywords",
        this.$store.state.stt.keywords
      );
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        // let tempId = this.$store.state.sysInit.manualChatQuestionerId;
        let tempId = this.$store.state.sysInit.manualChatModeIssueId;
        this.$store.state.stt.title = "SUBJECT";
        if (this.$store.state.openAi.estimateQuestion.length > 0) {
          this.$store.state.stt.title = this.$store.state.openAi.estimateQuestion;
        }
        console.log(
          "this.$store.state.stt.manualChatKeyWordsObj",
          this.$store.state.stt.manualChatKeyWordsObj
        );
        try {
          if (
            JSON.stringify(this.$store.state.stt.manualChatKeyWordsObj) != "{}"
          ) {
            console.log("is null");
            if (
              JSON.stringify(
                this.$store.state.stt.manualChatKeyWordsObj[tempId]
              ) != "{}"
            ) {
              if (
                JSON.stringify(
                  this.$store.state.stt.manualChatKeyWordsObj[tempId].keywords
                ) != "{}"
              ) {
                let tempKeywords =
                  this.$store.state.stt.manualChatKeyWordsObj[tempId].keywords;
                console.log("tempKeywords", tempKeywords);

                for (const key in tempKeywords) {
                  this.keywordsArr.push({
                    key,
                    count: tempKeywords[key],
                  });
                }
                this.keywordsArr = orderBy(
                  this.keywordsArr,
                  ["count"],
                  ["desc"]
                );
                if (this.keywordsArr.length > 0) {
                  let str = "";
                  for (let j = 0; j < this.keywordsArr.length; j++) {
                    if (j == this.keywordsArr.length - 1) {
                      str += this.keywordsArr[j]["key"];
                    } else {
                      str += this.keywordsArr[j]["key"] + " ";
                    }
                  }
                  this.$store.state.stt.title = str;
                  if (this.$store.state.openAi.estimateQuestion.length > 0) {
                    this.$store.state.stt.title = this.$store.state.openAi.estimateQuestion;
                  }
                  this.$store.dispatch("stt/updateKeywordCategroy", {
                    category: tempKeywords,
                    issueId: this.$store.state.redmine.issue_id,
                    keyword: this.$store.state.stt.title,
                  });
                } else {
                  this.$store.state.stt.title = "SUBJECT";
                  if (this.$store.state.openAi.estimateQuestion.length > 0) {
                    this.$store.state.stt.title = this.$store.state.openAi.estimateQuestion;
                  }
                }
              }
            }
          }
        } catch (err) {
          console.log(err);
        }

        // }
      } else {
        // let tempKeywords = this.$store.state.stt.keywords
        for (const key in this.$store.state.stt.keywords) {
          this.keywordsArr.push({
            key,
            count: this.$store.state.stt.keywords[key],
          });
        }
        this.keywordsArr = orderBy(this.keywordsArr, ["count"], ["desc"]);
        if (this.keywordsArr.length > 0) {
          let str = "";
          for (let j = 0; j < this.keywordsArr.length; j++) {
            if (j == this.keywordsArr.length - 1) {
              str += this.keywordsArr[j]["key"];
            } else {
              str += this.keywordsArr[j]["key"] + " ";
            }
          }
          // TODO 
          this.$store.state.stt.title = str;
          // this.$store.state.stt.title = "テセントリク投与中断後の再開時用量調整に関する相談"
          if (this.$store.state.openAi.estimateQuestion.length > 0) {
            this.$store.state.stt.title = this.$store.state.openAi.estimateQuestion;
          }
          this.$store.dispatch("stt/updateKeywordCategroy", {
            issueId: this.$store.state.redmine.issue_id,
            keyword: this.$store.state.stt.title,
          });
        } else {
          this.$store.state.stt.title = "SUBJECT";
          if (this.$store.state.openAi.estimateQuestion.length > 0) {
            this.$store.state.stt.title = this.$store.state.openAi.estimateQuestion;
          }
        }
      }

      this.$store.state.sysInit.op_answered = false;

      this.$store.dispatch("stt/sttStop", {
        issueId: this.$store.state.redmine.issue_id,
      });
    },
    turnMicPause() {
      this.$store.dispatch("stt/turnMicPause");
      // this.$SIP.muteSession(this.$store.state.sysInit.searchConditionForm.phone_number)
      // this.$store.commit("sysInit/changeNavigationText", "音声テキスト変換機能が一時停止されました");
      this.$store.commit(
        "sysInit/changeNavigationText",
        this.$store.state.sysInit.html_const.cons_239_footer_pause_button
      );
      this.$store.state.stt.isScroll = false;
      this.$store.state.stt.isMouse = false;
      this.emptyTextStatus = "";
    },
    turnMicOn() {
      this.$store.dispatch("stt/turnMicOn");
      // this.$store.commit("sysInit/changeNavigationText", "音声テキスト変換機能が再開されました");
      this.$store.commit(
        "sysInit/changeNavigationText",
        this.$store.state.sysInit.html_const.cons_240_footer_reopen_button
      );
      this.$store.state.stt.isScroll = true;
      this.$store.state.stt.isMouse = true;
      this.emptyTextStatus = "start";
      // this.isMicPause = false;
      // this.$store.dispatch("stt/sttStart");
    },
    changeShowImmediately(event) {
      this.$store.dispatch(
        "sysInit/changeShowImmediately",
        this.$store.state.sysInit.showImmediately
      );
    },
    turnOffSwitch() {
      // 存在打开的开关时
      if (this.searchData.length > 0) {
        this.searchData = [];
        if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
          // MANUAL_CHAT_MODE
          this.$store.state.sysInit.manualChatMessageList.forEach(v => v.checked = false);
        } else {
          // 非MANUAL_CHAT_MODE
          this.$store.state.stt.sttNotes.forEach(v => v.checked = false);
        }
      }
    },
    handleSelectionChange(val) {
      // 更新Bookmark
      this.multipleSelection = val;

      // 对Bookmark列表进行排序
      this.multipleSelection = orderBy(this.multipleSelection, ["id"], ["asc"]);

      // 处理searchIndex和当前行
      if (val.length === 0) {
        // 移除全部Bookmark时，把searchIndex置为初始值-1
        this.searchIndex = -1;
      } else {
        // 新增或移除某个Bookmark时，把最后作成的那个Bookmark设置为当前行
        this.searchIndex = this.multipleSelection.findIndex(v => v.id === val[val.length - 1].id);
      }
      this.setCurrentRow(this.searchIndex);

      // 更新Redmine
      this.$store.dispatch("redmine/updateHighLightHis", {
        data: this.multipleSelection,
      });
    },
    selectRow(row, column, event) {
      if (!row.checkBoxFlg) {
        row.checkBoxFlg = true;
      } else if (row.checked) {
        row.checkBoxFlg = false;
      } else if (!row.checked) {
        row.checkBoxFlg = false;
      } else {
        row.checkBoxFlg = false;
      }

      this.currentId = row.id;

      this.$refs.multipleTable.toggleRowSelection(row);
    },
    changeSwitch(row) {
      if (row.checked) {
        // 勾选上时触发行点击作成Bookmark
        if (this.multipleSelection.findIndex(v => v.id === row.id) === -1) {
          this.selectRow(row);
        }
        // 更新searchData - 新增当前行
        this.searchData.push(row)
      } else {
        // 更新searchData - 移除当前行
        ArraryOperation.remove(this.searchData, (n) => n.id == row.id);
      }
      const keyword = this.searchData.map((v) => v.text).join("");
      if (keyword) {
        this.$store.dispatch("sysInit/changeQueryNote", keyword);
        this.$store.commit(
          "sysInit/changeNavigationText",
          this.$store.state.sysInit.html_const.cons_236_footer_chat_msg
        );
        // Discovery检索
        this.$store.dispatch("discovery/fetchDisResults", {
          collections: this.collections,
          input: keyword,
          search_flag: "stt",
        });
        // ChatGPT检索
        let userContent = this.getDialogue();
        this.$store.dispatch("openAi/openAiSearch",{ userContent,type:"dialogue"});
        // this.$store.dispatch("discovery/fetchDocumentDisResults", { 
        //   collections: this.$store.state.discovery.documentSearchCollection, 
        //   input: keyword, 
        //   search_flag: 'dis-web-crawl' });
      }
    },
    downSelect() {
      if (this.multipleSelection.length) {
        if (this.searchIndex + 1 >= this.multipleSelection.length) {
          // 向下移动到底部后再次点击回到顶部
          this.searchIndex = 0;
        } else {
          // 正常向下移动
          this.searchIndex += 1;
        }
        this.setCurrentRow(this.searchIndex);
      }
    },
    upSelect() {
      if (this.multipleSelection.length) {
        if (this.searchIndex == 0) {
          // 向上移动到顶部后再次点击回到底部
          this.searchIndex = this.multipleSelection.length - 1;
        } else {
          // 正常向上移动
          this.searchIndex -= 1;
        }
        this.setCurrentRow(this.searchIndex);
      }
    },
    setCurrentRow(i) {
      if (i === -1) {
        // 没有任何Bookmark时取消选中
        this.$refs.multipleTable.setCurrentRow();
      } else {
        // 选中指定的Bookmark
        this.$refs.multipleTable.setCurrentRow(this.multipleSelection[i]);
        
        // 使用 nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          // 获取所有消息列表（根据模式不同处理）
          let allMessageList = [];
          if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
            allMessageList = this.$store.state.sysInit.manualChatMessageList.filter(v => {
              return v.userId === this.$store.state.sysInit.manualChatQuestionerId &&
              v.issueId == this.$store.state.sysInit.manualChatModeIssueId
            });
          } else {
            allMessageList = this.sttNotes;
          }
          
          // 找到当前选中的Bookmark在所有消息中的索引
          let index = allMessageList.findIndex(v => v.id === this.multipleSelection[i].id);
          
          if (index !== -1) {
            const scrollParent = this.$refs.multipleTable.$el.querySelector(".el-table__body-wrapper");
            const targetRow = this.$refs.multipleTable.$el.querySelectorAll(".el-table__body tr")[index];
            
            if (targetRow && scrollParent) {
              // 获取滚动容器和目标行的位置信息
              const containerRect = scrollParent.getBoundingClientRect();
              const targetRect = targetRow.getBoundingClientRect();
              
              // 计算目标行相对于滚动容器的位置
              const targetOffsetTop = targetRow.offsetTop;
              const containerScrollTop = scrollParent.scrollTop;
              const containerHeight = scrollParent.clientHeight;
              
              // 判断目标行是否在可见区域内
              const isVisible = targetRect.top >= containerRect.top && 
                               targetRect.bottom <= containerRect.bottom;
              
              if (!isVisible) {
                // 如果不在可见区域，滚动到目标位置
                // 将目标行滚动到容器中间位置
                const targetScrollTop = targetOffsetTop - (containerHeight / 2) + (targetRow.clientHeight / 2);
                scrollParent.scrollTop = targetScrollTop;
              }
            }
          }
        });
      }
    },
    onMouseEnter() {
      if (this.$store.state.stt.isMouse) this.$store.state.stt.isScroll = false;
    },
    onMouseLeave() {
      if (this.$store.state.stt.isMouse) this.$store.state.stt.isScroll = true;
    },
    stopScrollControl() {
      this.$store.state.stt.scrollFlag = false;
      this.$store.state.stt.isMouse = false;
      this.$store.state.stt.isScroll = false;
    },
    startScrollControl() {
      this.$store.state.stt.scrollFlag = true;
      this.$store.state.stt.isMouse = true;
      this.$store.state.stt.isScroll = true;
    },
    onScroll() {
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        const containerTop = this.$refs.multipleTable.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().height;
        const scrollParent = this.$refs.multipleTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
        scrollParent.scrollTop = containerTop;
      } else {
        if (this.$store.state.stt.isScroll) {
          const containerTop = this.$refs.multipleTable.$el
            .querySelector(".el-table__body")
            .getBoundingClientRect().height;
          const scrollParent = this.$refs.multipleTable.$el.querySelector(
            ".el-table__body-wrapper"
          );
          scrollParent.scrollTop = containerTop;
        }
      }
      console.log(
        "this.$store.state.stt.isScroll1:",
        this.$store.state.stt.isScroll
      );
    },
    // 书签拷贝
    movePart: function () {
      this.$store.state.stt.sttNotesSave = [];
      this.$store.state.stt.sttNotesCopy = "";
      // this.multipleSelection

      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        let singleMessageList = [];
        for (let selection of this.multipleSelection) {
          if (
            selection.userId === this.$store.state.sysInit.manualChatQuestionerId &&
            selection.issueId == this.$store.state.sysInit.manualChatModeIssueId
          ) {
            // OP消息
            let newUser = selection.user;
            if (selection.user === 'system') {
              // 系统消息，主要为もっぴー
              newUser = "";
            } else if (selection.user === 'user') {
              // Customer消息
              newUser = this.$store.state.sysInit.html_const.cons_217_questioner;
            }
            singleMessageList.push({...selection, user: newUser});
          }
        }
        this.$store.state.stt.sttNotesCopy = singleMessageList
          .map((v) => {
            let text = v.text;
            if (v.images && v.images.length) {
              for (let image of v.images) {
                text += `\n${image}`;
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${text}` : `${v.username}　:　${text}`;
          })
          .join("\n");
          this.$store.state.stt.sttNotesSave = singleMessageList
          .map((v) => {
            let text = v.text;
            if (v.images && v.images.length) {
              for (let image of v.images) {
                // 按照Redmine中富文本的语法，在图片URL的两侧添加叹号可以使之以图片形式表示
                text += `\n!${encodeURI(image)}!`;
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${text}` : `${v.username}　:　${text}`;
          })
          .join("\n");
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
      ) {
        this.$store.state.stt.sttNotesCopy = this.multipleSelection
          .map((v) => {
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
        this.$store.state.stt.sttNotesSave = this.$store.state.stt.sttNotesCopy;
      } else if (this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE") {
        this.$store.state.stt.sttNotesCopy = this.multipleSelection
          .map((v) => {
            return `${v.username}　:　${v.text}`;
          })
          .join("\n");
        this.$store.state.stt.sttNotesSave = this.$store.state.stt.sttNotesCopy;
      }
    },
    // 复制编辑后内容
    copyPart: function () {
      console.log(
        "this.$store.state.stt.sttNotesCopy",
        this.$store.state.stt.sttNotesCopy
      );
      let self = this;
      this.$copyText(this.$store.state.stt.sttNotesCopy || "").then(
        function (e) {
          Message.success(
            self.$store.state.sysInit.html_const
              .cons_232_copied_successfully_msg
          );
        },
        function (e) {
          console.log(e);
        }
      );
    },
    sendGPT(type) {
      if (this.isGPTLoading) return
      this.isGPTLoading = true;
      this.$store.state.stt.sttNotesCopy = "";
      this.$store.state.stt.sttNotesSave = "";
      console.log("ws_mode:", this.$store.state.sysInit.ws_mode)
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        let singleMessageList = [];
        for (let manualChatMessage of this.$store.state.sysInit.manualChatMessageList) {
          if (
            manualChatMessage.userId === this.$store.state.sysInit.manualChatQuestionerId &&
            manualChatMessage.issueId == this.$store.state.sysInit.manualChatModeIssueId
          ) {
            // 如果消息中只有图片没有文字内容，即text属性为空，则跳过。
            // 把图片或图片链接发送给ChatGPT没有意义
            if (manualChatMessage.text) {
              // OP消息
              let newUser = manualChatMessage.user;
              if (manualChatMessage.user === 'system') {
                // 系统消息，主要是もっぴー
                newUser = "";
              } else if (manualChatMessage.user === 'user') {
                // Customer消息
                newUser = this.$store.state.sysInit.html_const.cons_217_questioner;
              }
              singleMessageList.push({...manualChatMessage, user: newUser});
            }
          }
        }
        let userRoleMap = {};
        let userContent = singleMessageList
          .map((v) => {
            // 如果是会话形式要约
            if (type === 1) {
              // 如果不是系统消息
              if (v.user) {
                // 如果还没有添加到userRoleMap
                if (!userRoleMap[v.username]) {
                  // 添加到userRoleMap
                  userRoleMap[v.username] = v.user;
                }
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
        console.log('userContent', userContent)
        api.gptChat({ userContent, type }).then((res) => {
          if (res.data) {
            if (res.data.data) {
              let content = res.data.data.choices[0].message.content;
              // 点击的是会话形式要约按钮时，ChatGPT答复后进行后处理
              if (type === 1) {
                content = this.postProcessSendGpt(content, userRoleMap);
              }
              this.$store.state.stt.sttNotesCopy = content;
              this.$store.state.stt.sttNotesSave = content;
              this.isGPTLoading = false;
            } else {
              this.$message.error(res.data.msg || 'System error');
              this.isGPTLoading = false;
            }
          } else {
            this.$message.error('System error');
            this.isGPTLoading = false;
          }
        })
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE" ||
        this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE"
      ) {
        let userRoleMap = {};
        let userContent = this.sttNotes
          .map((v) => {
            // 如果是会话形式要约
            if (type === 1) {
              // 如果不是系统消息
              if (v.user) {
                // 如果还没有添加到userRoleMap
                if (!userRoleMap[v.username]) {
                  // 添加到userRoleMap
                  userRoleMap[v.username] = v.user;
                }
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
        console.log("userContent:", userContent)
        api.gptChat({ userContent, type }).then((res) => {
          if (res.data) {
            if (res.data.data) {
              let content = res.data.data.choices[0].message.content;
              // 点击的是会话形式要约按钮时，ChatGPT答复后进行后处理
              if (type === 1) {
                content = this.postProcessSendGpt(content, userRoleMap);
              }
              content = content.replace(/（.*?）/g, '');
              this.$store.state.stt.sttNotesCopy = content;
              this.$store.state.stt.sttNotesSave = content;
              this.isGPTLoading = false;
            } else {
              this.$message.error(res.data.msg || 'System error');
              this.isGPTLoading = false;
            }
          } else {
            this.$message.error('System error');
            this.isGPTLoading = false;
          }
        })
      }
    },
    // 以会话形式要约的方式使用ChatGPT时，对ChatGPT的处理结果进行二次加工
    // 主要内容为，如果用户名后面没有带上相应的角色，那么添加上角色。
    // 也包括对一些特殊字符进行处理
    postProcessSendGpt(res, userRoleMap) {
      if (res) {
        // 重新组装用Array
        let arr = [];
        // 段落分隔符
        let separator = '\n';
        // 每一段讲话
        let splittedArr = res.split(separator);
        // 匹配替换用Array
        // 第一种Case，用户: XXX
        // 第二种Case，<用户>: XXX
        // 第三种Case，<用户（角色）>: XXX
        // 第四种到第六种分别为前三种Case中去除用户名中半角空格的Case，比如 ナ リス -> ナリス
        // 每一种Case都替换成 用户（角色）: XXX
        let regArr = [];
        for (let user of Object.keys(userRoleMap)) {
          let trimmedUser = user.replaceAll(' ', '');
          regArr.push(
            {from: new RegExp(`^${user}:`), to: `${user}（${userRoleMap[user]}）:`},
            {from: new RegExp(`^<${user}>:`), to: `${user}（${userRoleMap[user]}）:`},
            {from: new RegExp(`^<${user}（${userRoleMap[user]}）>:`), to: `${user}（${userRoleMap[user]}）:`},
            {from: new RegExp(`^${trimmedUser}:`), to: `${user}（${userRoleMap[user]}）:`},
            {from: new RegExp(`^<${trimmedUser}>:`), to: `${user}（${userRoleMap[user]}）:`},
            {from: new RegExp(`^<${trimmedUser}（${userRoleMap[user]}）>:`), to: `${user}（${userRoleMap[user]}）:`},
          )
        }
        // 遍历处理每一段讲话
        for (let splittedStr of splittedArr) {
          // 去除每一段讲话末尾多余的\\n，该字符并不是请求时传给ChatGPT的内容，而是某些情况下ChatGPT返回的结果中莫名其妙多加的内容
          let _splittedStr = splittedStr.replace(/\\n$/, '');
          // 处理每一段讲话开头的用户角色
          for (let {from, to} of regArr) {
            if (from.test(_splittedStr)) {
              _splittedStr = _splittedStr.replace(from, to);
              break;
            }
          }
          arr.push(_splittedStr);
        }
        // 重新以换行符连接成字符串
        return arr.join(separator);
      }
      return res;
    },
    // 全文拷贝
    moveAll() {
      this.$store.state.stt.sttNotesCopy = "";
      this.$store.state.stt.sttNotesSave = "";
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        let singleMessageList = [];
        for (let manualChatMessage of this.$store.state.sysInit.manualChatMessageList) {
          if (
            manualChatMessage.userId === this.$store.state.sysInit.manualChatQuestionerId &&
            manualChatMessage.issueId == this.$store.state.sysInit.manualChatModeIssueId
          ) {
            // OP消息
            let newUser = manualChatMessage.user;
            if (manualChatMessage.user === 'system') {
              // 系统消息，主要为もっぴー
              newUser = "";
            } else if (manualChatMessage.user === 'user') {
              // Customer消息
              newUser = this.$store.state.sysInit.html_const.cons_217_questioner;
            }
            singleMessageList.push({...manualChatMessage, user: newUser});
          }
        }
        this.$store.state.stt.sttNotesCopy = singleMessageList
          .map((v) => {
            let text = v.text;
            if (v.images && v.images.length) {
              for (let image of v.images) {
                text += `\n${image}`;
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${text}` : `${v.username}　:　${text}`;
          })
          .join("\n");
        this.$store.state.stt.sttNotesSave = singleMessageList
          .map((v) => {
            let text = v.text;
            if (v.images && v.images.length) {
              for (let image of v.images) {
                // 按照Redmine中富文本的语法，在图片URL的两侧添加叹号可以使之以图片形式表示
                text += `\n!${encodeURI(image)}!`;
              }
            }
            return v.user ? `${v.username}（${v.user}）　:　${text}` : `${v.username}　:　${text}`;
          })
          .join("\n");
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
      ) {
        this.$store.state.stt.sttNotesCopy = this.sttNotes
          .map((v) => {
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
        this.$store.state.stt.sttNotesSave = this.$store.state.stt.sttNotesCopy;
      } else if (this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE") {
        this.$store.state.stt.sttNotesCopy = this.sttNotes
          .map((v) => {
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
        this.$store.state.stt.sttNotesSave = this.$store.state.stt.sttNotesCopy;
      }
    },
    editTable() {
      this.editAndSaveFlag = false;
      this.editAndSaveStatus = false;
    },
    saveTable() {
      this.editAndSaveFlag = true;
      this.editAndSaveStatus = true;
      // console.log(this.sttNotesTotal)
    },
    reload() {
      this.$emit('saveConfig')
      // Message.success('AICC Redmineへ自動チケット起票がされました。');
      Message.success(
        this.$store.state.sysInit.html_const.cons_234_redmine_success_msg
      );

      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        this.$store.dispatch("sysInit/updateIssueForManualChat");
        // this.$store.dispatch("sysInit/chatPiWsClose");
        // this.$store.dispatch("sysInit/chatPiMessageClose");
      }

      this.$store.dispatch("stt/updateSubjectByIssueId", {
        issueId: this.$store.state.redmine.issue_id,
        keyword: this.$store.state.stt.title,
      });
      // UNSOLVED issues are escalated automatically; all other outcomes clear the flag.
      this.$store.dispatch("redmine/updateEscalation", {
        escalation: this.currentAction === "UNSOLVED" ? 1 : 0,
      });
      this.$store.dispatch(
        "redmine/updateSttNotesEdit",
        this.$store.state.stt.sttNotesSave
      );
      if (this.$store.state.sysInit.ws_mode != "MANUAL_CHAT_MODE") {
        this.$store.dispatch("stt/changeOnCallFlag");
      }

      this.$store.dispatch("redmine/updateIssueStatus", {
        status: this.$store.state.sysInit.issue_Status,
      });

      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        this.currentAction = 'ON GOING';
        let tempId = this.$store.state.sysInit.manualChatModeIssueId; //////
        let tempUserId = this.$store.state.sysInit.manualChatQuestionerId;
        remove(this.$store.state.sysInit.manualChatMessageList, function (i) {
          // return i.userId == tempId;
          console.log(i);
          return i.issueId == tempId;
        });
        this.$store.state.sysInit.manualChatMessageList.sort();

        this.$store.state.stt.sttNotesCopy = "";
        this.$store.state.stt.sttNotesSave = "";

        remove(this.sttNotesTotal, function (i) {
          // return i.userId == tempId;
          return i.issueId == tempId;
        });

        remove(this.$store.state.sysInit.manualChatStartTimeList, function (i) {
          return i.issueId == tempId;
        });
        this.$store.state.stt.manualChatKeyWordsObj = omit(
          this.$store.state.stt.manualChatKeyWordsObj,
          tempId
          // tempId
        ); /////
        remove(this.$store.state.sysInit.chatBotUserIdList, function (i) {
          return i == tempUserId;
        });

        remove(this.$store.state.sysInit.waitCloseIssueId, function (i) {
          return i == tempId;
        });

        remove(this.$store.state.sysInit.holdOnUserList, function (i) {
          return i == tempId;
        });
        // holdon
        remove(this.$store.state.sysInit.holdOnUserList, function (i) {
          return i == tempId;
        });
        this.$store.state.sysInit.showHoldOnButton = true;
        this.$store.state.sysInit.manualChatSendMessageFlg = true;
        this.$store.state.sysInit.writingFlg = "false";
        this.$store.state.discovery.autoCompleteInputText = "";
        this.$store.state.discovery.editorText = "";

        this.$store.state.sysInit.issue_Status = "1";
        // this.$store.state.sysInit.dropdownText = "ON GOING";

        this.$store.state.store_sv.sv_help_isBlingFlg = false;
        this.$store.state.store_sv.sv_help_onSupportFlg = false;
        this.$store.state.store_sv.isSvTalkBlingFlg = false;

        this.multipleSelection = [];

        // console.log(
        //   "this.$store.state.stt.manualChatKeyWordsObj",
        //   this.$store.state.stt.manualChatKeyWordsObj
        // );
        this.$store.state.stt.title = "";
        console.log(
          "this.$store.state.discovery.collections",
          this.$store.state.discovery.collections
        );
        for (let i of this.$store.state.discovery.collections) {
          i.searchInfo = "";
          i.dataList = [];
        }
        this.$store.dispatch("openAi/initData");
        // this.$store.state.discovery.collections.dataList//

        // this.$store.state.sysInit.currentKeyword = "",
        // console.log("this.$store.state.stt.sttNotesTotal", this.sttNotesTotal);
      }
      if (this.$store.state.sysInit.ws_mode != "MANUAL_CHAT_MODE") {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    deleteRow(index) {
      this.sttNotesTotal = this.sttNotesTotal.filter((v, i) => {
        if (index != i) {
          return v;
        }
      });
    },
    clearInput() {
      this.$store.state.stt.title = "";
    },
    checkInput(event) {
      // タイトル、回答欄必須チェック
      if (
        this.$store.state.stt.title == "" ||
        this.$store.state.stt.sttNotesSave == ""
      ) {
        Message.warning(
          this.$store.state.sysInit.html_const.cons_233_subject_warning_msg
        );
        return;
      }
      this.reload();
    },

    // $store.state.stt.isDisabl
    dialogControl() {
      this.$store.state.stt.dialogVisible = false;
    },
    ws_dialogControl() {
      console.log("ws_dialogControl - キャンセル押下、通話状態を維持する");
      // ダイアログを閉じるだけで、通話状態はそのまま維持する
      this.$store.state.stt.dialogVisible = false;
    },
    // Determine the type of access terminal
    isMobile() {
      console.log("navigator.userAgent:", navigator.userAgent);
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad)/i
      );
      const w_flag = navigator.userAgent.indexOf("Windows");
      if (flag) {
        this.aside_width = "45%";
        console.log("Mobile terminal open", this.aside_width);
        this.$store.commit("sysInit/changeDraggableFlag", false);
      } else if (w_flag) {
        this.aside_width = "35%";
        console.log("PC terminal open", this.aside_width);
        this.$store.commit("sysInit/changeDraggableFlag", true);
      }
    },
    //       isMobile(){
    //          var b = {//判断浏览器内核
    //     v: function () {
    //       var u = navigator.userAgent, app = navigator.appVersion;
    //       return {//移动终端浏览器版本信息
    //         trident: u.indexOf('Trident') > -1, //IE内核
    //         presto: u.indexOf('Presto') > -1, //opera内核
    //         webKit: u.indexOf('AppleWebKit') > -1, //苹果内核
    //         chrome: u.indexOf("chrome") > -1, //谷歌内核
    //         gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    //         mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
    //         ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    //         android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
    //         iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
    //         iPad: u.indexOf('iPad') > -1, //是否iPad
    //         webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    //         wx: u.indexOf("MicroMessenger") > 0 //是否是微信
    //       };
    //     }(),
    //     language: (navigator.browserLanguage || navigator.language).toLowerCase()
    //   }
    //   if (b.v.webApp){
    //    this.aside_width = "45%"
    // console.log("navigator.userAgent:",navigator.userAgent)
    //   }else if(b.v.chrome){
    // this.aside_width = "45%"
    // console.log("navigator.userAgent:",navigator.userAgent)
    //   }
    //       }
    filterMessage({ row, column, rowIndex, columnIndex }) {
      console.log("row.userId", row.userId);
      if (row.userId != this.$store.state.sysInit.manualChatQuestionerId) {
        console.log(rowIndex);
        return "visibility:hidden";
      }
      return "";
    },

    // filterChange(filterObj) {
    //   console.log(filterObj);
    // },

    // getDeviceScreen
    getDeviceScreen() {
      let styleChangeHeight = window.innerHeight + "px";
      let styleChangeWidth = window.innerWidth + "px";
      console.log("styleChangeHeight", styleChangeHeight);
      console.log("styleChangeWidth", styleChangeWidth);
      if (window.innerWidth <= "1280") {
        this.aside_width = "40%";
        console.log("Mobile terminal open", this.aside_width);
        this.$store.commit("sysInit/changeDraggableFlag", false);
      } else {
        this.aside_width = "35%";
        console.log("PC terminal open", this.aside_width);
        this.$store.commit("sysInit/changeDraggableFlag", true);
      }
    },
    //close pi dialog
    // closePiDialog() {
    //   this.dialogTableVisible = false;
    // },
    // 录音（语音转文本）
    recordAudio() {
      console.log("录音 recordAudio");
      let that = this;
      console.log(document.getElementById("myQuillEditor"));
      this.$store.state.sysInit.chatSttConfig["format"] = true;
      this.$store.state.sysInit.chatSttConfig["keepMicrophone"] = false;

      this.$store.state.sysInit.chatSttConfig["outputElement"] =
        that.$refs.myQuillEditor;
      this.$store.state.stt.stream =
        AzureSpeech.SpeechToText.recognizeMicrophone(
        this.$store.state.sysInit.sttConfig
      );
      this.$store.state.stt.stream.on("data", function () {
        console.log("recognizing result:", that.$refs.myQuillEditor.textContent);
        that.$nextTick(() => {
          that.$store.state.discovery.autoCompleteInputText =
            that.$refs.myQuillEditor.textContent;
        });
      });
      this.$store.state.stt.recordAudioFlg = false;
    },
    // 停止录音
    stopRecordAudio() {
      console.log("停止录音 stopRecordAudio");
      if (this.$store.state.stt.stream) {
        this.$store.state.stt.stream.stop();
        this.$store.state.stt.recordAudioFlg = true;
      }
    },

    inputOn() {
      this.onInputFlg = true;
      //        this.$nextTick(() => {

      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    textChangeEvent() {
      // isWriting
      if (this.$store.state.sysInit.manualChatQuestionerId) {
        if (
          this.$store.state.discovery.autoCompleteInputText &&
          this.onInputFlg
        ) {
          this.$store.state.sysInit.manualMessageStatus = "isWriting";
          this.$store.dispatch("sysInit/changeManualChatMessageStatus");
        } else {
          console.log(
            "this.$store.state.discovery.autoCompleteInputText is null"
          );
        }
      }
      //        this.$nextTick(() => {
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    chatBlur() {
      //  this.$nextTick(() => {
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    chatChange() {
      //  this.$nextTick(() => {
      // if(this.$refs.autoInput.$el.offsetHeight==48 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 156px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==66 ){
      //        this.$refs.sectionChat.style.height = "calc(100% - 174px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==84 ){
      //       this.$refs.sectionChat.style.height = "calc(100% - 192px)"
      //      }else if(this.$refs.autoInput.$el.offsetHeight==102 ){
      //         this.$refs.sectionChat.style.height = "calc(100% - 210px)"
      //      }else{
      //         this.$refs.sectionChat.style.height = "calc(100% - 138px)"
      //      }
      //        })
    },

    pasteDescription(event) {
      //    this.$nextTick(() => {
      //     console.log(event.clipboardData.getData('Text'));
      //     let data = event.clipboardData.getData('Text');
      //     let tempTimer =   setTimeout(() => {
      //       document.getElementById("autoInput").value  = document.getElementById("autoInput").value + " ";
      //        this.$refs.autoInput.handleBlur();
      //        clearTimeout(tempTimer);
      //     }, 500);
      //  })
    },
    /**
		 * 仕様変更：JAL-demo
		 *
		 * 変更前: api.sendMessageToOperatorがgetメソッドので、特別な符号を入力したら、転換しないと正しく発送できない
		 * 変更後: 特別な符号を入力したら、転換してURLにセットする
		 */

		/* 2022/1/26 comment out for JAL-demo: updated start line */
		changePunctuationInUrl(urlStr){
			return urlStr ? urlStr.replaceAll("%", "%25").replaceAll("+", "%2B").replaceAll("#", "%23").replaceAll("&", "%26") : ""
		},
		/* 2022/1/26 comment out for JAL-demo: updated end line */
    doSendMessage(message) {
      this.$store.state.sysInit.manualMessageStatus = "sendEnd";

      // 发送消息给Customer
      let messageAfterChange = this.changePunctuationInUrl(message.richText);
      this.$store.dispatch("sysInit/manualChatSendMessage", {
        message: messageAfterChange,
      });

      // 记录到Redmine
      let data = {
        id: this.$store.state.sysInit.messageId++,
        flag: "left",
        userId: this.$store.state.sysInit.manualChatQuestionerId,
        text: message.rawText,
        checked: false,
        user: this.$store.state.sysInit.html_const.cons_216_operator,
        messageTime: moment()
          .tz("Asia/Tokyo")
          .format("YYYY-MM-DD HH:mm:ss"),
        status: false,
        issueId: this.$store.state.sysInit.manualChatModeIssueId,
        isChatbot: false,
        username: this.$store.state.sysInit.user_name,
        editorText: message.richText,
        images: this.images.map(image => image.url),
      };
      this.$store.state.sysInit.manualChatMessageList.push(data);
      this.$store.dispatch(
        "redmine/manualChatMessageRecord",
        {},
        { root: true }
      );

      // ?
      let item = {
        flag: data.flag,
        text: message.rawText,
        mode: this.$store.state.sysInit.ws_mode,
      };

      this.$store.dispatch("stt/fetchKeywordByDialog", {
        ...item,
        request_id: this.$store.state.redmine.issue_id,
        keywordRate: this.$store.state.sysInit.keywordRate,
      });

      // 重置编辑器
      this.resetEditor();
    },

    querySearch(queryString, callBack) {
      //  this.$store.state.sysInit.autocompleteData
      // debugger
      // var autocompleteData = this.autocompleteData
      // var results = queryString ? autocompleteData.filter(item => {return item.value.toLowerCase().includes(queryString.toLowerCase())}) : autocompleteData
      // callBack(results)
      var alternatives = [];
      var rets = [];
      var ret = {};
      for (
        var i = 0;
        i < this.$store.state.sysInit.autocompleteData.length;
        i++
      ) {
        let restaurant = this.$store.state.sysInit.autocompleteData[i];
        if (restaurant["text"].indexOf(queryString) != -1) {
          if (alternatives.length == 0) {
            alternatives.push(restaurant);
            ret = {};
            ret["value"] = restaurant["text"];
            rets.push(ret);
          } else {
            if (
              restaurant["format"] !=
              alternatives[alternatives.length - 1]["format"]
            ) {
              alternatives.push(restaurant);
              ret = {};
              ret["value"] = restaurant["text"];
              rets.push(ret);
            }
          }
        } else if (
          restaurant["text"].toLowerCase().indexOf(queryString.toLowerCase()) !=
          -1
        ) {
          if (alternatives.length == 0) {
            alternatives.push(restaurant);
            ret = {};
            ret["value"] = restaurant["text"];
            rets.push(ret);
          } else {
            if (
              restaurant["format"] !=
              alternatives[alternatives.length - 1]["format"]
            ) {
              alternatives.push(restaurant);
              ret = {};
              ret["value"] = restaurant["text"];
              rets.push(ret);
            }
          }
        }
      }

      rets.forEach((item) => {
        item["index"] = item.value
          .toLowerCase()
          .indexOf(queryString.toLowerCase());
      });
      rets.sort((a, b) => {
        return a.index - b.index;
      });
      callBack(rets);
    },
    // 发送消息
    enterClick() {
      console.log('this.$refs.myQuillEditor.value', this.$refs.myQuillEditor.value);
      // console.log(document.getElementById("myQuillEditor").textContent);
      // 富文本
      let inputValue = this.$refs.myQuillEditor.value;
      // for (let image of this.images) {
      //   inputValue += `    <img src="${image.url}">    `
      // }
      // 纯文本
      this.$store.state.discovery.editorText = document.getElementById("myQuillEditor").textContent.trim();
      if (inputValue == null || inputValue == "" || inputValue == "\n") {
        this.$refs.myQuillEditor.value = "";
        return;
      }
      let that = this;
      var interval = setInterval(function () {
        if (
          !(
            that.$store.state.stt.stream &&
            that.$store.state.stt.stream.readable
          )
        ) {
          clearInterval(interval);
          that.$store.state.discovery.autoCompleteInputText = inputValue;
          that.sendMessage();
          // this.$refs.myQuillEditor.value = "";
          // resize(document.getElementById('input-text'));
        }
      }, 100);
      this.stopRecordAudio();
    },

    carriageReturn(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        let inputValue = this.$refs.myQuillEditor.value;
        // if (inputValue == null || inputValue == "" || inputValue == "\n") {
        //   document.getElementById("autoInput").value = "";
        //   this.message = this.$t("lang.input_error");
        //   this.messageVisible = true;
        //   this.$refs.autoInput.focus();
        //   return;
        // }
        let that = this;
        var interval = setInterval(function () {
          if (
            !(
              that.$store.state.stt.stream &&
              that.$store.state.stt.stream.readable
            )
          ) {
            clearInterval(interval);
            that.$store.state.discovery.autoCompleteInputText = inputValue;
            that.sendMessage();
            // this.$refs.myQuillEditor.value = "";
          }
        }, 100);
        this.stopRecordAudio();
      }
    },
    cellStyle_table({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "text-align: left;border: none";
      } else {
        return "border: none";
      }
    },

    escapeStringHTML(str) {
      str = str.replace(/</g, "<");
      str = str.replace(/>/g, ">");
      return str;
    },
    onclickForm() {
      console.log($store.state.discovery.autoCompleteInputText);
      this.content = "";
    },
    getDialogue(){
      let dialogueContent
      if (this.$store.state.sysInit.ws_mode === "MANUAL_CHAT_MODE") {
        let singleMessageList = [];
        for (let manualChatMessage of this.$store.state.sysInit.manualChatMessageList) {
          if (
            manualChatMessage.userId === this.$store.state.sysInit.manualChatQuestionerId &&
            manualChatMessage.issueId == this.$store.state.sysInit.manualChatModeIssueId
          ) {
            // 如果消息中只有图片没有文字内容，即text属性为空，则跳过。
            // 把图片或图片链接发送给ChatGPT没有意义
            if (manualChatMessage.text) {
              // OP消息
              let newUser = manualChatMessage.user;
              if (manualChatMessage.user === 'system') {
                // 系统消息，主要是もっぴー
                newUser = "";
              } else if (manualChatMessage.user === 'user') {
                // Customer消息
                newUser = this.$store.state.sysInit.html_const.cons_217_questioner;
              }
              singleMessageList.push({...manualChatMessage, user: newUser});
            }
          }
        }
        dialogueContent = singleMessageList
          .map((v) => {
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
      } else if (
        this.$store.state.sysInit.ws_mode === "NEXMO_ASTERISK_PBX_MODE"
        || this.$store.state.sysInit.ws_mode === "STAND_MIC_MODE"
      ) {
        dialogueContent = this.sttNotes
          .map((v) => {
            return v.user ? `${v.username}（${v.user}）　:　${v.text}` : `${v.username}　:　${v.text}`;
          })
          .join("\n");
      }
      console.log('dialogueContent',dialogueContent)
      return  dialogueContent

    },
    getCalltimeText(){
      console.log('getCalltimeText this.$store.state.stt.sttStartTime',this.$store.state.stt.sttStartTime)
      console.log('getCalltimeText this.$store.state.stt.endTime',this.$store.state.stt.endTime)
      let startTimeArray = this.$store.state.stt.startTime.split(":");
      let endTimeArray =  this.$store.state.stt.endTime.split(":")
      let startTime =Number(startTimeArray[0]) *60 *60 +  Number(startTimeArray[1]) * 60 + Number(startTimeArray[2])
      let endTime = Number(endTimeArray[0]) *60 *60 + Number(endTimeArray[1]) * 60 + Number(endTimeArray[2])
      let diffTime =  endTime - startTime 
      if (diffTime < 60) {
        return  diffTime + this.$store.state.sysInit.html_const.cons_280_stop_call_time_seconds
      }else {
        return  Math.floor(diffTime/60) +this.$store.state.sysInit.html_const.cons_226_stop_call_time_minutes + (diffTime%60 >0 ? diffTime%60 + this.$store.state.sysInit.html_const.cons_280_stop_call_time_seconds :'')
      }
    },
    buildAllTextForAcwAndNextAction() {
      if (!this.sttNotesTotal || this.sttNotesTotal.length === 0) {
        return '';
      }
      return this.sttNotesTotal
        .map((v) => {
          const message = v.editorText || v.text || '';
          return v.user ? `${v.username}（${v.user}）　:　${message}` : `${v.username}　:　${message}`;
        })
        .join("\n");
    },
    inferAcwContentFromAllText(allText) {
      if (!allText) {
        return '自己解決';
      }

      // Keep this mapping aligned with chugai_voice_bot/app/rag/voice_log.py.
      // The backend trusts this frontend-inferred ACW tag when saving Redmine.
      //  const patterns = [
      //   ['エスカレーション', 'OPへのエスカレーション'],
      //   ['お繋ぎ', 'OPへのエスカレーション'],
      // ];
      const patterns = [
        // [['資材請求', '資材の請求', '資材の発注'], '資材請求'],
        // [['担当MR', 'MRよりご連絡', 'MRからご連絡', '担当者の呼び出し'], '担当MRのお呼び出し'],
        // [['CMディスパッチ', 'CM手配', 'CMへ連携'], 'CMディスパッチ'],
        // [['SVエスカレーション', 'SVへ連携', '上席へエスカレーション'], 'SVエスカレーション'],
        // [['2次CMエスカレーション', '二次CMエスカレーション', '2次CMへ連携'], '2次CMエスカレーション'],
        [['資材請求'], '資材請求'],
        [['担当MRコールバック','コールバック','電話がほしい'], '担当MRコールバック依頼'],
        [['担当MR訪問','訪問依頼','訪問してほしい'], '担当MR訪問依頼'],
      ];

      let lastEndPos = -1;
      let lastKeywordLength = -1;
      let lastValue = '自己解決';

      // Prefer the tag whose keyword ends latest in the transcript.
      // If two keywords end at the same position, prefer the longer phrase.
      for (const [keywords, value] of patterns) {
        for (const keyword of keywords) {
          const index = allText.lastIndexOf(keyword);
          if (index === -1) {
            continue;
          }

          const endPos = index + keyword.length;
          if (endPos > lastEndPos || (endPos === lastEndPos && keyword.length > lastKeywordLength)) {
            lastEndPos = endPos;
            lastKeywordLength = keyword.length;
            lastValue = value;
          }
        }
      }
      return lastValue;
    },
    generateAcwAndNextAction() {
      const issueId = this.$store.state.redmine.issue_id || this.$store.state.phone.redmineIssueId;
      const allText = this.buildAllTextForAcwAndNextAction();
      const acwContent = this.inferAcwContentFromAllText(allText);

      this.nextActionError = '';
      this.nextActionText = '';
      this.acwContent = acwContent;

      if (!issueId) {
        this.nextActionError = 'Issue ID is missing.';
        return;
      }

      this.nextActionLoading = true;
      api
        .generateAcwNextAction({
          issue_id: issueId,
          all_text: allText,
          acw_content: acwContent,
        })
        .then((res) => {
          const payload = res && res.data && res.data.data ? res.data.data : null;
          if (!payload) {
            this.nextActionError = 'Failed to generate next action.';
            return;
          }
          this.acwContent = payload.acwContent || acwContent;
          this.nextActionText = payload.nextAction || '';
          // Display the Dify title and preserve it for any later user edits.
          if (payload.title) {
            this.$store.state.stt.title = payload.title;
          }
        })
        .catch(() => {
          this.nextActionError = 'Failed to generate next action.';
        })
        .finally(() => {
          this.nextActionLoading = false;
        });
    },
    // 终了Dialog全文テキスト中根据row获取头像
    getDialogAvatarSrc(row) {
      if (row.flag === 'right') {
        // 问い合わせ者
        if (this.$store.state.sysInit.ws_mode === 'NEXMO_ASTERISK_PBX_MODE') {
          return this.$store.state.sysInit.phone_questioner_logo;
        }
        return this.$store.state.sysInit.questioner_logo;
      } else {
        // オペレーター / AI VOICEBOT
        return this.$store.state.sysInit.operator_logo;
      }
    },
    // 终了Dialog検索機能
    searchDialogText() {
      // 既に検索結果がある場合、Enterで次のマッチへ移動
      if (this.dialogSearchAllMatches.length > 0 && this.dialogSearchText) {
        this.dialogSearchNext();
        return;
      }
      this.buildSearchMatches();
    },
    // 検索マッチリストを構築
    buildSearchMatches() {
      this.dialogSearchAllMatches = [];
      this.dialogSearchMatches = [];
      this.dialogSearchCurrentIndex = 0;
      if (!this.dialogSearchText) return;

      const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const searchPattern = new RegExp(escapeRegex(this.dialogSearchText), 'gi');

      // 全文テキストから検索
      this.sttNotesTotal.forEach((row, rowIndex) => {
        const text = row.editorText || row.text || '';
        let match;
        let localIndex = 0;
        searchPattern.lastIndex = 0;
        while ((match = searchPattern.exec(text)) !== null) {
          this.dialogSearchAllMatches.push({ area: 'fulltext', rowIndex, localIndex });
          if (!this.dialogSearchMatches.includes(rowIndex)) {
            this.dialogSearchMatches.push(rowIndex);
          }
          localIndex++;
        }
      });

      // 編集後テキストから検索
      const editedText = this.$store.state.stt.sttNotesCopy || '';
      if (editedText) {
        let match;
        let localIndex = 0;
        searchPattern.lastIndex = 0;
        while ((match = searchPattern.exec(editedText)) !== null) {
          this.dialogSearchAllMatches.push({ area: 'edited', rowIndex: 0, localIndex });
          localIndex++;
        }
      }

      if (this.dialogSearchAllMatches.length > 0) {
        this.scrollToDialogSearchMatch();
      }
    },
    dialogSearchPrev() {
      if (this.dialogSearchAllMatches.length === 0) return;
      if (this.dialogSearchCurrentIndex <= 0) {
        this.dialogSearchCurrentIndex = this.dialogSearchAllMatches.length - 1;
      } else {
        this.dialogSearchCurrentIndex--;
      }
      this.scrollToDialogSearchMatch();
    },
    dialogSearchNext() {
      if (this.dialogSearchAllMatches.length === 0) return;
      if (this.dialogSearchCurrentIndex >= this.dialogSearchAllMatches.length - 1) {
        this.dialogSearchCurrentIndex = 0;
      } else {
        this.dialogSearchCurrentIndex++;
      }
      this.scrollToDialogSearchMatch();
    },
    scrollToDialogSearchMatch() {
      const currentMatch = this.dialogSearchAllMatches[this.dialogSearchCurrentIndex];
      if (!currentMatch) return;

      this.$nextTick(() => {
        if (currentMatch.area === 'fulltext' && this.$refs.multipleTable2) {
          const scrollParent = this.$refs.multipleTable2.$el.querySelector('.el-table__body-wrapper');
          const rows = this.$refs.multipleTable2.$el.querySelectorAll('.el-table__body tr');
          const rowIndex = currentMatch.rowIndex;
          if (rows[rowIndex] && scrollParent) {
            const targetOffsetTop = rows[rowIndex].offsetTop;
            const containerHeight = scrollParent.clientHeight;
            scrollParent.scrollTop = targetOffsetTop - containerHeight / 2 + rows[rowIndex].clientHeight / 2;
          }
        }
        // 編集後テキストの場合はスクロール不要（単一のdiv）
      });
    },
    handleActionClick(status) {
      // 改变当前选择的起票按钮
      this.currentAction = status;
      // 改变Issue状态
      this.changeIssueStauts(status);
      // 关闭Dialog
      this.$store.state.stt.dialogVisible2 = false;
    },
    // 全文テキスト内のキーワードをハイライト表示する（検索ハイライトも含む）
    highlightKeywords(text, rowIndex) {
      if (!text) return '';
      let result = text;

      // Step 1: キーワードハイライト（evalWord）
      const wordList = this.$store.state.stt.wordList || [];
      if (wordList.length > 0) {
        const colorMap = {
          'warning': '#f36a78',
          'ng': 'red',
          'wow': '#00bfff',
        };
        const keywordSet = {};
        wordList.forEach(item => {
          if (item.keyword) {
            const keywords = item.keyword.includes(',')
              ? item.keyword.split(',').map(k => k.trim()).filter(k => k)
              : [item.keyword];
            keywords.forEach(kw => {
              if (!keywordSet[kw]) {
                keywordSet[kw] = item.type;
              }
            });
          }
        });
        const keywords = Object.keys(keywordSet).sort((a, b) => b.length - a.length);
        if (keywords.length > 0) {
          const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const pattern = new RegExp(`(${keywords.map(escapeRegex).join('|')})`, 'g');
          result = result.replace(pattern, (match) => {
            const type = keywordSet[match];
            const color = colorMap[type] || '#26b1a0';
            return `<span style="color: ${color};">${match}</span>`;
          });
        }
      }

      // Step 2: 検索ハイライト
      if (this.dialogSearchText && this.dialogSearchAllMatches.length > 0) {
        const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const searchPattern = new RegExp(`(${escapeRegex(this.dialogSearchText)})`, 'gi');
        let matchIndex = 0;
        result = result.replace(searchPattern, (match) => {
          // このrowの中のマッチが現在のハイライト位置かどうかチェック
          const globalIdx = this.findGlobalMatchIndex('fulltext', rowIndex, matchIndex);
          matchIndex++;
          if (globalIdx === this.dialogSearchCurrentIndex) {
            return `<span class="search-highlight-current">${match}</span>`;
          }
          return `<span class="search-highlight">${match}</span>`;
        });
      }

      return result;
    },
    // 編集後テキストの検索ハイライト表示
    highlightEditedText(text) {
      if (!text) return '';
      if (!this.dialogSearchText || this.dialogSearchAllMatches.length === 0) return text.replace(/\n/g, '<br>');
      
      const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const searchPattern = new RegExp(`(${escapeRegex(this.dialogSearchText)})`, 'gi');
      let matchIndex = 0;
      let result = text.replace(searchPattern, (match) => {
        const globalIdx = this.findGlobalMatchIndex('edited', 0, matchIndex);
        matchIndex++;
        if (globalIdx === this.dialogSearchCurrentIndex) {
          return `<span class="search-highlight-current">${match}</span>`;
        }
        return `<span class="search-highlight">${match}</span>`;
      });
      return result.replace(/\n/g, '<br>');
    },
    // グローバルなマッチインデックスを取得
    findGlobalMatchIndex(area, rowIndex, localMatchIndex) {
      for (let i = 0; i < this.dialogSearchAllMatches.length; i++) {
        const m = this.dialogSearchAllMatches[i];
        if (m.area === area && m.rowIndex === rowIndex && m.localIndex === localMatchIndex) {
          return i;
        }
      }
      return -1;
    },
    getEvalWordClass(type) {
      const classMap = {
        'warning': 'eval-word-warning',
        'ng': 'eval-word-ng',
        'wow': 'eval-word-wow',
      };
      return classMap[type] || 'eval-word-default';
    },
    startDurationTimer() {
      // 每秒更新一次当前时间
      this.durationTimer = setInterval(() => {
        const now = moment().tz("Asia/Tokyo");
        this.currentTime = now.format("HH:mm:ss");
      }, 1000);
    },
    stopDurationTimer() {
      // 停止定时器
      if (this.durationTimer) {
        clearInterval(this.durationTimer);
        this.durationTimer = null;
      }
    },
  },
  created() {},
  mounted() {
    // 注册Quill模块
    this.registerQuillModules();
    // this.isMobile();
    this.getDeviceScreen();
    // this.piAnalyze("8618642396359");
    let content = ""; // 请求返回值
    this.str = this.escapeStringHTML(content);
    
    // 启动定时器更新当前时间
    this.startDurationTimer();

    // 从后台获取LONG_TIME_CALL配置
    api.getSystemConfig().then((res) => {
      if (res && res.data && res.data.data) {
        let uc3Configs = res.data.data;
        if (uc3Configs.length > 0) {
          let longTimeConfig = uc3Configs.find(config => config.func_name == "LONG_TIME_CALL");
          this.longTimeConfig = Number(longTimeConfig?.value) || 2;
        }
      }
    }, (err) => {
      console.log(err);
    });
  },
  beforeDestroy() {
    // 清除定时器
    if (this.durationTimer) {
      clearInterval(this.durationTimer);
      this.durationTimer = null;
    }
  },
};
</script>
<style lang="scss">
.footer-box {
  // background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%);
  position: relative;
  background-color: #94e3ff;
  // height: -webkit-fit-content;
  // height:50px;
  //  padding: 45px 0px 15px 0px;
  // height: 125px;
  height: fit-content;
  // padding: 10px 0px 9px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // .el-input {
  //   width: 80%;
  //   margin: 0px 10px;
  // }
  .el-autocomplete {
    flex: 1;
    margin: 0px 0px;
  }
  .el-button--mini {
    margin: 0px 10px;
  }
  :deep(.el-autocomplete-suggestion li) {
    padding: 10px 0px;
    white-space: normal;
    line-height: normal;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    // height: 36px!important;
    padding: 5px 0px;
    font-size: 16px;
    color: inherit;
  }
}
.footer-box3 {
  background-image: linear-gradient(to right, #bbb 0%, #bbb 100%);
  // height: 125px;
  height: fit-content;
  // padding: 10px 0px 9px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // .el-input {
  //   width: 80%;
  //   margin: 0px 10px;
  // }
  .el-autocomplete {
    flex: 1;
    margin: 0px 0px;
  }
  .el-button--mini {
    margin: 0px 10px;
  }
  :deep(.el-autocomplete-suggestion li) {
    padding: 10px 0px;
    white-space: normal;
    line-height: normal;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    // height: 36px!important;
    padding: 5px 0px;
    font-size: 16px;
    color: inherit;
  }

  .breath_light {
    /*IE10、Firefox and Opera*/
    animation-name: breath;
    animation-duration: 2.5s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    /* Safari and Chrome */
    -webkit-animation-name: breath;
    -webkit-animation-duration: 2.5s;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: infinite;
  }
  @keyframes breath {
    from {
      fill: #ff0602;
    }
    50% {
      fill: #ffa08c;
    }
    to {
      fill: #ff0602;
    }
  }

  @-webkit-keyframes breath {
    from {
      fill: #ff0602;
    }
    50% {
      fill: #ffa08c;
    }
    to {
      fill: #ff0602;
    }
  }
}
.footer-box-phone {
  background-image: linear-gradient(to right, #bbb 0%, #bbb 100%);
  // height: fit-content;
  height: 100px;
  // padding: 8px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // .el-input {
  //   width: 80%;
  //   margin: 0px 10px;
  // }
  .el-autocomplete {
    flex: 1;
    margin: 0px 0px;
  }
  .el-button--mini {
    margin: 0px 10px;
  }
  :deep(.el-autocomplete-suggestion li) {
    padding: 10px 0px;
    white-space: normal;
    line-height: normal;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    // height: 36px!important;
    padding: 5px 0px;
    font-size: 16px;
    color: inherit;
  }

  .breath_light {
    /*IE10、Firefox and Opera*/
    animation-name: breath;
    animation-duration: 2.5s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    /* Safari and Chrome */
    -webkit-animation-name: breath;
    -webkit-animation-duration: 2.5s;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: infinite;
  }
  @keyframes breath {
    from {
      fill: #ff0602;
    }
    50% {
      fill: #ffa08c;
    }
    to {
      fill: #ff0602;
    }
  }

  @-webkit-keyframes breath {
    from {
      fill: #ff0602;
    }
    50% {
      fill: #ffa08c;
    }
    to {
      fill: #ff0602;
    }
  }
}

.el-autocomplete-suggestion__wrap {
  height: 120px;
  padding: 10px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-autocomplete-suggestion {
  position: absolute;
  top: -129px;
  margin: 5px 0;
  box-shadow: 0 2px 12px 0rgba (0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
}
.chat-dialog-card {
  .el-card__body {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
}
// append-to-bodyのダイアログ内のel-dividerスタイル（scopedでは効かないのでここに定義）
.close-dialog .dialog-left-sidebar .el-divider--horizontal {
  display: block;
  height: 1px;
  margin: 10px 0 0 0;
  background-color: #dcdfe6;
  position: relative;
}
.result-content-chat {
  // height: calc(100% - 55px);
  // height: calc(100% - 134px);
  flex: 1;
  // padding-top: 75px;
  position: relative;
  .el-table {
    margin-top: unset;
  }
}
.result-content-chat-isWriting {
  // height: calc(100% - 55px);
  height: calc(100% - 130px);
  padding-top: 75px;
  position: relative;
}

.controlbar-chat {
  // position: absolute;
  z-index: 1000;
  // width: 31%;
}

//  .editor_container :deep(.ql-editor) 
//   /* min-height: 50px;
//   background: white;
//   height: 50px; */

//       min-height: 65px;
//       max-height: 65px;
//     background: white;
//     position: relative;
//     width: 400px;
//         padding: 5px;
//             top: -18px;
//         line-height: 1;

// }

.ql-toolbar.ql-snow {
  position: relative;
  border: 0px solid #ccc;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif; */
  /* top: 625px; */
  /* padding: 8px; */
  // width: 430px;
  /* position: absolute; */
  /* z-index: 1000; */
  padding: 0px;
}

.ql-container.ql-snow {
  border: 0px solid #ccc;
}

@keyframes rotate-action-icon {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.editor_container {
  padding-bottom: 20px;
  .images-area {
    display: flex;
    align-items: center;
    width: 400px;
    overflow: auto hidden;
    background-color: #fff;
    .image-container {
      padding: 10px 0 5px 10px;
      .image-wrapper {
        position: relative;
        .action-icon {
          position: absolute;
          top: 0;
          right: 0;
          transform: translateX(50%) translateY(-50%);
          border: 2px solid #fff;
          border-radius: 50%;
          display: none;
          z-index: 100;
          cursor: pointer;
          svg {
            border-radius: 50%;
          }
          &.upload {
            svg {
              animation: rotate-action-icon 1.2s cubic-bezier(.25, .29, .54, .86) infinite;
            }
          }
          &.delete {
            &:hover {
              background-color: #666;
            }
          }
        }
        &.status-uploading {
          .action-icon.upload {
            display: block;
          }
        }
        &.status-failed {
          .action-icon.error {
            display: block;
          }
        }
        &.status-succeed:hover {
          .action-icon.delete {
            display: block;
          }
        }
        &.status-failed:hover {
          .action-icon.error {
            display: none;
          }
          .action-icon.delete {
            display: block;
          }
        }
        .el-image {
          width: 50px;
          height: 50px;
          border-radius: 20%;
          border: 1px solid #ccc;
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.cate_type{
  background-color: #e9f5cf;
  border-color: #26b1a0;
  color: #26b1a0;
  border-style: solid;
  border-radius: 4px;
  border-width: 2px;
  display: inline-block;
  height: 28px;
  padding: 0 10px;
  margin: 10px 10px 0px 0px;
  line-height: 23px;
}
.editor_container ::v-deep(.ql-editor) {
  /* min-height: 50px;
  background: white;
  height: 50px; */

  min-height: 90px;
  /* max-height: 90px; */
  max-height: calc((100vh - 66px) / 2 - 40px);
  background: white;
  position: relative;
  width: 400px;
  padding: 5px;
  line-height: 1.5;
}
.dialog-footer-btn-area {
  display: flex;
  justify-content: center;
  margin-top: 7px;

  .footer_btn {
    // background: chartreuse;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: 5px;
  }

  .footer_btn_disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .footer_btn_icon {
    width: 100%;
    height: 100%;
  }
}
// お疲れ様でした画面全文テキスト和編集後テキスト区域
.all-text-and-edited-text {
  display: flex;
  column-gap: 20px;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
}
.all-text-area, .edited-text-area, .next-action-area {
  width: calc((100% - 40px) / 3);
  min-width: 0;
}
.copy-all-row, .copy-all-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  min-height: 37px;
  color: #000;
}
.all-text-container {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  :deep(.el-table__empty-block) {
    width: 100% !important;
  }
}
// お疲れ様でした画面全文テキスト内容容器和編集後テキスト内容容器
.all-text-container, .edited-text-container {
  margin-top: 10px;
  :deep(.el-table__body-wrapper) {
    width: 100%;
  }
  :deep(table) {
    width: 100% !important;
  }
  :deep(.el-table__body-wrapper) {
    padding: 5px 15px;
  }
}
.edited-text-container {
  :deep(.el-textarea__inner) {
    height: 520px;
  }
  .edited-text-highlight-overlay {
    height: 520px;
    overflow-y: auto;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 5px 15px;
    font-size: 13px;
    line-height: 1.5;
    color: #606266;
    background-color: #fff;
    white-space: pre-wrap;
    word-break: break-word;
  }
}

.next-action-container {
  height: 520px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 12px;
  margin-top: 10px;
  background-color: #fff;
  overflow-y: auto;
  box-sizing: border-box;

  .next-action-content {
    font-size: 13px;
    line-height: 1.7;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .next-action-list {
    margin: 0;
    padding-left: 24px;
    list-style: decimal outside;
  }

  .next-action-list li {
    padding-left: 4px;
    margin-bottom: 6px;
    line-height: 1.7;
  }

  .next-action-empty {
    font-size: 13px;
    color: #909399;
    line-height: 1.6;
  }
}

// お疲れ様でした画面标题栏和起票按钮中间的内容区域
.dialog-content {
  min-height: 700px;
  overflow: hidden auto;
  padding: 8px 20px 20px 20px;
}
// お疲れ様でした画面第一行单选框
.dialog-content .flag {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
// お疲れ様でした画面
.close-dialog {
  border-radius: 0;
  padding: 0 !important;
  :deep(.el-dialog) {
    width: calc(100% - 150px) !important;
    min-width: 800px;
    height: calc(100% - 60px);
    margin: 0 !important;
    border-radius: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  :deep(.el-dialog__header) {
    background-color: #5aaafa;
    padding: 4px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    box-sizing: border-box;
  }
  :deep(.el-dialog__title) {
    color: #fff;
    font-size: 13px;
    font-weight: normal;
    white-space: nowrap;
    padding-top:7px;
  }
  :deep(.el-dialog__headerbtn) {
    top: 8px;
    right: 16px;
    .el-dialog__close {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
  }
  :deep(.el-dialog__body) {
    padding: 0;
    height: calc(100% - 38px);
    overflow: hidden;
  }
  :deep(.el-dialog__wrapper) {
    overflow: hidden;
  }
}
// ヘッダー検索バー
.dialog-header-search {
  display: inline-flex;
  align-items: center;
  margin-left: 100px;
  .dialog-search-input {
    width: 635px;
    :deep(.el-input__inner) {
      border-radius: 4px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      border: 2px solid grey;
    }
  }
  .dialog-search-count {
    color: #fff;
    padding: 0 4px;
    font-size: 12px;
    white-space: nowrap;
    line-height: 38px;
  }
  .dialog-search-nav-btn {
    width: 20px;
    height: 20px;
    padding: 0;
    background-color: #6d6d6d !important;
    border-color: #6d6d6d !important;
    color: #fff !important;
    min-width: 0.625rem;
    border-radius: 3px;
    i {
      font-size: 12px;
    }
  }
}
.category-tag-row {
  font-weight: 700;
}
// 如果消息中只有图片没有文本内容，则不允许打开消息左侧的检索开关
.switch-wrapper {
  cursor: not-allowed;
  border-radius: 20px;
  .switch-disabled {
    pointer-events: none;
  }
}

.gray-button {
		background-color: #909399 !important;
		border-color: #909399 !important;
		color: #fff !important;
	}

	.gray-button:hover,
	.gray-button:focus {
		background-color: #7d7f82 !important;
		border-color: #7d7f82 !important;
	}
  .search-nav-btn {
    width: 20px;
    height: 20px;
    padding: 0;
    min-width:0.625rem;
  }
  .search-nav-btn i {
    width: 20px;
    min-width: 20px;
    height: 20px;
    padding: 0;
    margin-top: 10px; /* 40pxヘッダー内で中央寄せ */
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .selectStatus {
    display: flex;
    align-items: center;
  }

// ============================================
// 終了Dialog新レイアウト（左サイドバー＋右コンテンツ）
// ============================================
.dialog-content-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

// 左サイドバー
.dialog-left-sidebar {
  width: 302px;
  min-width: 302px;
  border-right: solid 1px #e4e7ed;
  padding: 0px 16px;
  overflow-y: auto;
  height: 99.7%;
  box-sizing: border-box;
  background-color: #fff;
  border-right: 2px solid #e0dede;

  .sidebar-divider {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0 0 0;
    background-color: #dcdfe6;
  }
}

.left-sidebar-section {
  .left-sidebar-section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: normal;
    color: #303133;
    line-height: 28px;
    margin-top: 10px;

    i {
      color: #909399;
      font-size: 16px;
    }
  }

  .left-sidebar-section-content {
    margin-top: 3px;
    padding-left: 10px;
    font-size: 13px;
    color: #606266;
    line-height: 22px;
  }

  .left-sidebar-empty {
    color: #909399;
    font-size: 13px;
  }

  .left-sidebar-small-text {
    font-size: 13px;
    line-height: 22px;
    color: #606266;
  }

}

// 右メインエリア
.dialog-right-main {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
}

// 通話者情報
.dialog-user-info {
  display: flex;
  vertical-align: middle;
  line-height: 32px;
  padding-top: 10px;
  padding-left: 20px;

  .dialog-user-avatar {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }

  .dialog-user-name {
    margin-left: 10px;
 
  }

  .dialog-user-separator {
    margin: 0 16px;
    font-size: 14px;
    color: #909399;
  }
}

// タイトルセクション
.dialog-subject-section {
  padding: 10px 20px;
}

// 全文テキスト - Sentence行スタイル
.dialog-sentence-row {
  display: flex;
  align-items: flex-start;
  line-height: 28px;
  padding: 6px 0;

  .dialog-sentence-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    min-width: 36px;
    padding-right: 8px;
    padding-top: 2px;

    :deep(.el-avatar) {
      width: 32px;
      height: 32px;
      line-height: 32px;
    }
  }

  .dialog-sentence-content {
    flex: 1;
    padding-left: 10px;
    padding-right: 17px;
    word-break: break-word;
    font-size: 13.5px;
    line-height: 26px;
    color: #303133;
    border-left: solid 1px #e4e7ed;
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

// 起票ボタンエリア（右メインエリア内）
.dialog-right-main .action {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 24px;
  // Keep ticket action buttons visually aligned even when labels have different lengths.
  .ticket-action-btn {
    width: 180px;
    min-height: 52px;
    padding: 8px 12px;
    margin-left: 0;
    white-space: normal;
    line-height: 1.25;
  }
  // Split the button label into a fixed two-line stack.
  .ticket-action-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .currentActionOnGoing {
    color: #ffffff;
    border-color: #67C23A;
    background-color: #67C23A;
  }
  .currentActionSolved {
    color: #ffffff;
    border-color: #409EFF;
    background-color: #409EFF;
  }
  .currentActionUnSolved {
    color: #ffffff;
    border-color: #F56C6C;
    background-color: #F56C6C;
  }
}

.dialog-right-main .flag {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

// アラート通知タグスタイル
.detected-alerts {
  box-sizing: border-box;
  margin-top: 3px;
  padding-left: 10px;
  min-height: 32px;
}
.detected-alerts ::v-deep .el-tag {
  background-color: #fff;
  border-color: #fff;
  color: #fff;
  padding: 0 10px 5px 0;
}
.detected-alerts ::v-deep .alert-sv {
  background-color: #e2d6ec;
  border-color: #7030a0;
  color: #7030a0;
}
.detected-alerts ::v-deep .alert-ng {
  background-color: #ff000026;
  border-color: red;
  color: red;
}
.detected-alerts ::v-deep .alert-long-time {
  background-color: #d5934f54;
  border-color: #d5934f;
  color: #d5934f;
}
.detected-alerts ::v-deep .alert-warning-tag {
  background-color: #ef58933b;
  border-color: #ef5893;
  color: #ef5893;
}
.detected-alerts ::v-deep .alert-wow {
  background-color: #00bfff26;
  border-color: #00bfff;
  color: #00bfff;
}
.detected-alerts ::v-deep .alert-acw-content {
  background-color: #80008024;
  border-color: purple;
  color: purple;
}
.el-tag-common {
  border-radius: 16px;
  border-width: 1px;
  font-size: 12px;
  border-style: solid;
  display: inline-block;
  height: 20px;
  line-height: 18px;
  padding: 0 10px;
  text-align: center;
}

// 評価ワードタグスタイル
.eval-word-tags {
  box-sizing: border-box;
  margin-top: 3px;
  padding-left: 10px;
  min-height: 32px;
}
.eval-word-tags ::v-deep .el-tag {
  background-color: #fff;
  border-color: #fff;
  color: #fff;
  padding: 0 10px 5px 0;
}
.eval-word-tags ::v-deep .eval-word-warning {
  background-color: #ef58933b;
  border-color: #ef5893;
  color: #ef5893;
}
.eval-word-tags ::v-deep .eval-word-ng {
  background-color: #ff000026;
  border-color: red;
  color: red;
}
.eval-word-tags ::v-deep .eval-word-wow {
  background-color: #00bfff26;
  border-color: #00bfff;
  color: #00bfff;
}
.eval-word-tags ::v-deep .eval-word-default {
  background-color: #e9f5cf;
  border-color: #26b1a0;
  color: #26b1a0;
}

// 検索ハイライトスタイル
::v-deep .search-highlight {
  background-color: #ff0;
}
::v-deep .search-highlight-current {
  background-color: #adff2f;
  color: #00bfff;
}
</style>
